// Finn poenggrensene her: https://rapport-dv.educloud.no/t/SO-datavarehus/views/Poenggrenserogventelistetallhovedopptaksuppleringsopptak_16275618215770/Poenggrenser?:display_count=n&:embed=y&:isGuestRedirectFromVizportal=y&:origin=viz_share_link&:showAppBanner=false&:showVizHome=n
// Bruk en CSV til JSON converter for å få dataen inn i riktig format (Husk å sjekke overskriftene)

const fieldsOfStudy = [
  {
    Studiekode: '189 343',
    Studienavn: 'Design*',
    Lærested: 'AHO',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 153.1,
    ORD: 149.2,
  },
  {
    Studiekode: '189 030',
    Studienavn: 'Arkitekt*',
    Lærested: 'AHO',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - ARKITEKT',
    ORDF: 142.8,
    ORD: 148.6,
  },
  {
    Studiekode: '189 732',
    Studienavn: 'Landskapsarkitektur*',
    Lærested: 'AHO',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 144.2,
    ORD: 144.7,
  },
  {
    Studiekode: '185 740',
    Studienavn: 'Medisin, Oslo, høst',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 60.5,
    ORD: 69.6,
  },
  {
    Studiekode: '194 740',
    Studienavn: 'Medisin, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 61,
    ORD: 68.5,
  },
  {
    Studiekode: '194 767',
    Studienavn: 'Industriell økonomi og teknologiledelse',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 61.5,
    ORD: 68.4,
  },
  {
    Studiekode: '185 498',
    Studienavn: 'Medisin, Oslo/Kristiansand, høst',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 58.6,
    ORD: 68.3,
  },
  {
    Studiekode: '185 941',
    Studienavn: 'Psykologi , høst',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 57,
    ORD: 68.1,
  },
  {
    Studiekode: '185 745',
    Studienavn: 'Medisin, Oslo, vår',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 58.1,
    ORD: 68.1,
  },
  {
    Studiekode: '185 497',
    Studienavn: 'Medisin, Oslo/Innlandet, høst',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 57.7,
    ORD: 68,
  },
  {
    Studiekode: '185 499',
    Studienavn: 'Medisin, Oslo/Kristiansand, vår',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 57.8,
    ORD: 67.8,
  },
  {
    Studiekode: '184 740',
    Studienavn: 'Medisin, Bergen',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 58.5,
    ORD: 67.2,
  },
  {
    Studiekode: '194 498',
    Studienavn: 'Medisin, Trondheim/Levanger',
    Lærested: 'NTNU',
    Studiested: 'Levanger',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 58.6,
    ORD: 67,
  },
  {
    Studiekode: '185 942',
    Studienavn: 'Psykologi , vår',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 56.1,
    ORD: 67,
  },
  {
    Studiekode: '194 499',
    Studienavn: 'Medisin, Trondheim/Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 58.2,
    ORD: 66.9,
  },
  {
    Studiekode: '194 497',
    Studienavn: 'Medisin, Trondheim/Gjøvik',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 57.5,
    ORD: 66.6,
  },
  {
    Studiekode: '185 588',
    Studienavn: 'Filosofi, politikk og økonomi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 56.2,
    ORD: 66.5,
  },
  {
    Studiekode: '184 499',
    Studienavn: 'Medisin, Bergen/Stavanger',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 57.6,
    ORD: 66.3,
  },
  {
    Studiekode: '184 498',
    Studienavn: 'Medisin, Bergen/Førde',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 56.8,
    ORD: 66.1,
  },
  {
    Studiekode: '186 740',
    Studienavn: 'Medisin',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - MEDISIN',
    ORDF: 57.1,
    ORD: 66,
  },
  {
    Studiekode: '194 941',
    Studienavn: 'Psykologi, profesjonsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 57.5,
    ORD: 65.7,
  },
  {
    Studiekode: '185 742',
    Studienavn: 'Odontologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 56.2,
    ORD: 65.7,
  },
  {
    Studiekode: '184 941',
    Studienavn: 'Psykologi, profesjonsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 56.6,
    ORD: 65.7,
  },
  {
    Studiekode: '186 941',
    Studienavn: 'Psykologi, profesjonsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 56.2,
    ORD: 65.6,
  },
  {
    Studiekode: '184 742',
    Studienavn: 'Odontologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 56,
    ORD: 65.1,
  },
  {
    Studiekode: '185 724',
    Studienavn: 'Rettsvitenskap (jus), høst',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'JUS',
    ORDF: 56.4,
    ORD: 64.7,
  },
  {
    Studiekode: '185 366',
    Studienavn: 'Filosofi, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 46.7,
    ORD: 64.2,
  },
  {
    Studiekode: '186 742',
    Studienavn: 'Odontologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 55.1,
    ORD: 64,
  },
  {
    Studiekode: '215 162',
    Studienavn: 'Økonomi og ledelse',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 50.2,
    ORD: 63.9,
  },
  {
    Studiekode: '185 725',
    Studienavn: 'Rettsvitenskap (jus), vår',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'JUS',
    ORDF: 54.6,
    ORD: 63.6,
  },
  {
    Studiekode: '209 171',
    Studienavn: 'Regnskap og økonomirådgivning, nettbasert',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 35.6,
    ORD: 63.5,
  },
  {
    Studiekode: '191 340',
    Studienavn: 'Business, economics and data science - siviløkonom',
    Lærested: 'NHH',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 59.2,
    ORD: 63.5,
  },
  {
    Studiekode: '185 239',
    Studienavn: 'Samfunnsøkonomi, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 48.1,
    ORD: 63.5,
  },
  {
    Studiekode: '194 218',
    Studienavn: 'Økonomi og administrasjon, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORDF: 52.2,
    ORD: 62.7,
  },
  {
    Studiekode: '184 803',
    Studienavn: 'Informasjonsteknologi og økonomi (sivilingeniør)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 57.2,
    ORD: 62.6,
  },
  {
    Studiekode: '184 724',
    Studienavn: 'Rettsvitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'JUS',
    ORDF: 54.7,
    ORD: 62.2,
  },
  {
    Studiekode: '194 760',
    Studienavn: 'Datateknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 57.3,
    ORD: 62.1,
  },
  {
    Studiekode: '192 772',
    Studienavn: 'Veterinærmedisin',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORDF: 53.5,
    ORD: 62.1,
  },
  {
    Studiekode: '185 474',
    Studienavn: 'Honoursprogram, Samfunnsvitenskap',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 55.8,
    ORD: 62.1,
  },
  {
    Studiekode: '185 340',
    Studienavn: 'Økonomi og datavitenskap',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 51.6,
    ORD: 62.1,
  },
  {
    Studiekode: '215 604',
    Studienavn: 'Medier og kommunikasjon, årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 45.5,
    ORD: 62,
  },
  {
    Studiekode: '186 724',
    Studienavn: 'Rettsvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'JUS',
    ORDF: 54,
    ORD: 62,
  },
  {
    Studiekode: '194 798',
    Studienavn: 'Kybernetikk og robotikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 58.6,
    ORD: 61.8,
  },
  {
    Studiekode: '194 768',
    Studienavn: 'Industriell design',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 57,
    ORD: 61.8,
  },
  {
    Studiekode: '194 583',
    Studienavn: 'Økonomi og ledelse, deltid, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 61.5,
  },
  {
    Studiekode: '194 007',
    Studienavn: 'Ingeniør, flyingeniør',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 56.7,
    ORD: 61.5,
  },
  {
    Studiekode: '185 751',
    Studienavn: 'Kriminologi, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 52.8,
    ORD: 61.5,
  },
  {
    Studiekode: '217 554',
    Studienavn: 'Paramedisin',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 50.1,
    ORD: 61.4,
  },
  {
    Studiekode: '185 752',
    Studienavn: 'Psykologi, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 50.9,
    ORD: 61.4,
  },
  {
    Studiekode: '194 345',
    Studienavn: 'Økonomi og administrasjon, siviløkonom',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORDF: 54.3,
    ORD: 61.3,
  },
  {
    Studiekode: '209 449',
    Studienavn: 'Økonomi og administrasjon, Rena, bachelor, nettbasert',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 45.4,
    ORD: 60.8,
  },
  {
    Studiekode: '203 242',
    Studienavn: 'Samfunnsfag',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 60.7,
  },
  {
    Studiekode: '185 874',
    Studienavn: 'Kriminologi, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 53.1,
    ORD: 60.6,
  },
  {
    Studiekode: '215 744',
    Studienavn: 'Ortopediingeniør',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ORTOPEDI',
    ORDF: 44.4,
    ORD: 60.5,
  },
  {
    Studiekode: '185 898',
    Studienavn: 'Samfunnsøkonomi, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 50.3,
    ORD: 60.5,
  },
  {
    Studiekode: '185 872',
    Studienavn: 'Internasjonale studier',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 54.3,
    ORD: 60.5,
  },
  {
    Studiekode: '217 526',
    Studienavn: 'Rettsvitenskap',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'JUS',
    ORDF: 53.1,
    ORD: 60,
  },
  {
    Studiekode: '191 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Lærested: 'NHH',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 55.3,
    ORD: 59.9,
  },
  {
    Studiekode: '185 747',
    Studienavn: 'Honoursprogram, Realfag',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 60.1,
    ORD: 59.9,
  },
  {
    Studiekode: '185 272',
    Studienavn: 'Kunsthistorie og visuelle studier, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 59.5,
  },
  {
    Studiekode: '194 855',
    Studienavn: 'Bioteknologi, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 56.2,
    ORD: 59.4,
  },
  {
    Studiekode: '186 703',
    Studienavn: 'Fysioterapi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORDF: 53.3,
    ORD: 59.2,
  },
  {
    Studiekode: '194 762',
    Studienavn: 'Maskin- og energiteknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 56.8,
    ORD: 59.1,
  },
  {
    Studiekode: '185 831',
    Studienavn: 'Informatikk: maskinlæring og kunstig intelligens',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 44.3,
    ORD: 59.1,
  },
  {
    Studiekode: '201 526',
    Studienavn: 'Rettsvitenskap',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'JUS',
    ORDF: 53.5,
    ORD: 59,
  },
  {
    Studiekode: '194 703',
    Studienavn: 'Fysioterapi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORDF: 52.9,
    ORD: 59,
  },
  {
    Studiekode: '184 783',
    Studienavn: 'Medisinsk teknologi (sivilingeniør)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 55.8,
    ORD: 58.8,
  },
  {
    Studiekode: '215 620',
    Studienavn: 'Informasjonsteknologi, årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 36.4,
    ORD: 58.7,
  },
  {
    Studiekode: '185 222',
    Studienavn: 'Tverrfaglige kjønnsstudier, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 42.1,
    ORD: 58.6,
  },
  {
    Studiekode: '204 057',
    Studienavn: 'Sykepleie, deltid, Orkland',
    Lærested: 'NORD',
    Studiested: 'Orkland',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 42.7,
    ORD: 58.5,
  },
  {
    Studiekode: '194 646',
    Studienavn: 'Film- og videoproduksjon',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 52,
    ORD: 58.3,
  },
  {
    Studiekode: '184 454',
    Studienavn: 'Journalistikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 52.8,
    ORD: 58.3,
  },
  {
    Studiekode: '194 035',
    Studienavn: 'Økonomi og administrasjon, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORDF: 53,
    ORD: 58.2,
  },
  {
    Studiekode: '192 233',
    Studienavn: 'Frie realfag',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 58.2,
  },
  {
    Studiekode: '217 906',
    Studienavn: 'Toll, vareførsel og grensekontroll',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'JUS',
    ORDF: 49.2,
    ORD: 58.1,
  },
  {
    Studiekode: '194 770',
    Studienavn: 'Cybersikkerhet og datakommunikasjon',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 54.5,
    ORD: 58,
  },
  {
    Studiekode: '185 370',
    Studienavn: 'Informatikk: digital økonomi og ledelse',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 46.8,
    ORD: 58,
  },
  {
    Studiekode: '222 845',
    Studienavn: 'Kunst og design i samfunn - digital mediedesign',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 36.1,
    ORD: 57.8,
  },
  {
    Studiekode: '194 765',
    Studienavn: 'Marin teknikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 55.3,
    ORD: 57.8,
  },
  {
    Studiekode: '194 763',
    Studienavn: 'Fysikk og matematikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 57.8,
    ORD: 57.8,
  },
  {
    Studiekode: '184 534',
    Studienavn: 'Film- og TV-produksjon',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 52.4,
    ORD: 57.8,
  },
  {
    Studiekode: '185 876',
    Studienavn: 'Psykologi, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 50,
    ORD: 57.5,
  },
  {
    Studiekode: '185 698',
    Studienavn: 'Samfunnsøkonomisk analyse',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 46.1,
    ORD: 57.5,
  },
  {
    Studiekode: '184 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 39.6,
    ORD: 57.4,
  },
  {
    Studiekode: '194 239',
    Studienavn: 'Samfunnsøkonomi, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORDF: 48.9,
    ORD: 57.3,
  },
  {
    Studiekode: '185 465',
    Studienavn: 'Helseledelse og helseøkonomi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 45,
    ORD: 57.3,
  },
  {
    Studiekode: '184 903',
    Studienavn: 'Arbeids- og organisasjonspsykologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 52.1,
    ORD: 57.3,
  },
  {
    Studiekode: '185 830',
    Studienavn: 'Informatikk: design, bruk og interaksjon',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 38.1,
    ORD: 57.2,
  },
  {
    Studiekode: '194 937',
    Studienavn: 'Nanoteknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 57.3,
    ORD: 57.1,
  },
  {
    Studiekode: '192 767',
    Studienavn: 'Industriell økonomi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 52.6,
    ORD: 57.1,
  },
  {
    Studiekode: '194 898',
    Studienavn: 'Samfunnsøkonomi, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORDF: 50.4,
    ORD: 57,
  },
  {
    Studiekode: '184 876',
    Studienavn: 'Generell psykologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 52.1,
    ORD: 56.9,
  },
  {
    Studiekode: '233 571',
    Studienavn: 'Politiutdanning, Alta',
    Lærested: 'PHS',
    Studiested: 'Alta',
    Utdanningsområde: 'JUS',
    ORDF: '',
    ORD: 56.8,
  },
  {
    Studiekode: '215 554',
    Studienavn: 'Paramedisin',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 47.3,
    ORD: 56.8,
  },
  {
    Studiekode: '185 381',
    Studienavn: 'Matematikk: finans, forsikring og økonomi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 45.8,
    ORD: 56.8,
  },
  {
    Studiekode: '185 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 46.9,
    ORD: 56.8,
  },
  {
    Studiekode: '203 583',
    Studienavn: 'HRM og ledelse',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 47.6,
    ORD: 56.7,
  },
  {
    Studiekode: '194 819',
    Studienavn: 'Ingeniørgeologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 54.8,
    ORD: 56.7,
  },
  {
    Studiekode: '194 034',
    Studienavn: 'Ingeniør, maskin',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 53.2,
    ORD: 56.7,
  },
  {
    Studiekode: '185 240',
    Studienavn: 'Sosiologi, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 46.3,
    ORD: 56.7,
  },
  {
    Studiekode: '194 422',
    Studienavn: 'Digital forretningsutvikling',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 50.5,
    ORD: 56.5,
  },
  {
    Studiekode: '194 404',
    Studienavn: 'Økonomi og ledelse, deltid, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 56.5,
  },
  {
    Studiekode: '185 464',
    Studienavn: 'Matematikk: teoretisk og anvendt matematikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 56.4,
  },
  {
    Studiekode: '251 752',
    Studienavn: 'Anvendt psykologi',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 44.8,
    ORD: 56.3,
  },
  {
    Studiekode: '194 809',
    Studienavn: 'Georessurser og geoteknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 55.2,
    ORD: 56.3,
  },
  {
    Studiekode: '192 732',
    Studienavn: 'Landskapsarkitektur*',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 52,
    ORD: 56.3,
  },
  {
    Studiekode: '185 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 50.8,
    ORD: 56.3,
  },
  {
    Studiekode: '184 827',
    Studienavn: 'Fiskehelse - akvamedisin',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 44,
    ORD: 56.3,
  },
  {
    Studiekode: '209 526',
    Studienavn: 'Rettsvitenskap',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'JUS',
    ORDF: 51,
    ORD: 56.2,
  },
  {
    Studiekode: '204 554',
    Studienavn: 'Paramedisin, deltid',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 39.6,
    ORD: 56.2,
  },
  {
    Studiekode: '203 218',
    Studienavn: 'Digital økonomi og ledelse',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 47.6,
    ORD: 56.2,
  },
  {
    Studiekode: '194 823',
    Studienavn: 'Ingeniør, automatisering og intelligente systemer, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 53,
    ORD: 56,
  },
  {
    Studiekode: '185 609',
    Studienavn: 'Antikkens kultur',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 55.9,
  },
  {
    Studiekode: '184 430',
    Studienavn: 'Medie- og interaksjonsdesign',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 48.8,
    ORD: 55.9,
  },
  {
    Studiekode: '203 369',
    Studienavn: 'Økonomi og administrasjon, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 51.7,
    ORD: 55.8,
  },
  {
    Studiekode: '203 703',
    Studienavn: 'Fysioterapi',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORDF: 51.2,
    ORD: 55.7,
  },
  {
    Studiekode: '185 899',
    Studienavn: 'Tannpleie',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 46.1,
    ORD: 55.7,
  },
  {
    Studiekode: '150 583',
    Studienavn: 'Organisasjon og idrettsledelse , deltid',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 32.6,
    ORD: 55.6,
  },
  {
    Studiekode: '203 080',
    Studienavn: 'Sosialt arbeid, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 49.6,
    ORD: 55.5,
  },
  {
    Studiekode: '185 452',
    Studienavn: 'Offentlig administrasjon og ledelse',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 48.2,
    ORD: 55.5,
  },
  {
    Studiekode: '184 585',
    Studienavn: 'Data science (sivilingeniør)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 51.3,
    ORD: 55.5,
  },
  {
    Studiekode: '215 472',
    Studienavn: 'Kunst og design - mote og produksjon',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 49.9,
    ORD: 55.4,
  },
  {
    Studiekode: '192 199',
    Studienavn: 'Ettårig grunnstudium',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 52.6,
    ORD: 55.3,
  },
  {
    Studiekode: '215 701',
    Studienavn: 'Radiografi',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORDF: 47,
    ORD: 55.2,
  },
  {
    Studiekode: '215 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 49.3,
    ORD: 55.2,
  },
  {
    Studiekode: '194 905',
    Studienavn: 'Ingeniørvitenskap og IKT',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 53.9,
    ORD: 55.2,
  },
  {
    Studiekode: '194 756',
    Studienavn: 'Arkitektur',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - ARKITEKT',
    ORDF: 51.3,
    ORD: 55.2,
  },
  {
    Studiekode: '204 515',
    Studienavn: 'Økonomi og teknologiledelse',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 55.1,
  },
  {
    Studiekode: '194 859',
    Studienavn: 'Geologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 51.5,
    ORD: 55.1,
  },
  {
    Studiekode: '217 752',
    Studienavn: 'Psykologi, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 46.7,
    ORD: 55,
  },
  {
    Studiekode: '215 528',
    Studienavn: 'Dokumentasjonsforvaltning, deltid',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 55,
  },
  {
    Studiekode: '194 818',
    Studienavn: 'Samfunnsøkonomi, master',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ØKADM',
    ORDF: 49.8,
    ORD: 54.9,
  },
  {
    Studiekode: '184 395',
    Studienavn: 'Informatikk: bioinformatikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 46,
    ORD: 54.9,
  },
  {
    Studiekode: '194 940',
    Studienavn: 'Digital infrastruktur og cybersikkerhet, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 49.6,
    ORD: 54.7,
  },
  {
    Studiekode: '184 769',
    Studienavn: 'Energi (sivilingeniør)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 52.1,
    ORD: 54.7,
  },
  {
    Studiekode: '222 526',
    Studienavn: 'Jus',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'JUS',
    ORDF: 49.1,
    ORD: 54.6,
  },
  {
    Studiekode: '217 218',
    Studienavn: 'Økonomi og ledelse',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ØKADM',
    ORDF: 44.8,
    ORD: 54.6,
  },
  {
    Studiekode: '194 508',
    Studienavn: 'Bevegelsesvitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'IDRETT',
    ORDF: 48.6,
    ORD: 54.6,
  },
  {
    Studiekode: '215 602',
    Studienavn: 'Design og kommunikasjon i digitale medier, deltid',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 54.5,
  },
  {
    Studiekode: '209 515',
    Studienavn: 'Økonomi og administrasjon, deltid',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 54.5,
  },
  {
    Studiekode: '185 604',
    Studienavn: 'Medier og kommunikasjon, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 33.8,
    ORD: 54.5,
  },
  {
    Studiekode: '211 526',
    Studienavn: 'Rettsvitenskap',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'JUS',
    ORDF: 50,
    ORD: 54.4,
  },
  {
    Studiekode: '194 876',
    Studienavn: 'Psykologi, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 51.1,
    ORD: 54.4,
  },
  {
    Studiekode: '185 400',
    Studienavn: 'Idéhistorie, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 54.4,
  },
  {
    Studiekode: '184 837',
    Studienavn: 'Kognitiv vitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 48.1,
    ORD: 54.4,
  },
  {
    Studiekode: '209 404',
    Studienavn: 'Regnskap og økonomirådgivning, deltid',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 54.3,
  },
  {
    Studiekode: '194 702',
    Studienavn: 'Bioingeniør, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 50.7,
    ORD: 54.3,
  },
  {
    Studiekode: '194 554',
    Studienavn: 'Paramedisin',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 45.9,
    ORD: 54.3,
  },
  {
    Studiekode: '194 324',
    Studienavn: 'Samfunnsvitenskapelige fag, emnestudier',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 54.3,
  },
  {
    Studiekode: '215 454',
    Studienavn: 'Journalistikk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 47,
    ORD: 54.2,
  },
  {
    Studiekode: '184 765',
    Studienavn: 'Havteknologi (sivilingeniør)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 52.7,
    ORD: 54.2,
  },
  {
    Studiekode: '184 239',
    Studienavn: 'Samfunnsøkonomi, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 47.8,
    ORD: 54.2,
  },
  {
    Studiekode: '194 675',
    Studienavn: 'Ingeniør, bygg, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 49.9,
    ORD: 54.1,
  },
  {
    Studiekode: '194 597',
    Studienavn: 'Lektor i kroppsøving og idrettsfag, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 50.4,
    ORD: 54,
  },
  {
    Studiekode: '186 050',
    Studienavn: 'Sykepleie, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 48.1,
    ORD: 53.9,
  },
  {
    Studiekode: '209 207',
    Studienavn: 'Bedriftsøkonomi, deltid',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 53.8,
  },
  {
    Studiekode: '194 024',
    Studienavn: 'Ingeniør, elektronisk systemingeniør',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 49.9,
    ORD: 53.7,
  },
  {
    Studiekode: '230 050',
    Studienavn: 'Sykepleie',
    Lærested: 'LDH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 45.2,
    ORD: 53.6,
  },
  {
    Studiekode: '194 752',
    Studienavn: 'Psykologi, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 48.9,
    ORD: 53.6,
  },
  {
    Studiekode: '215 703',
    Studienavn: 'Fysioterapi',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORDF: 47.2,
    ORD: 53.5,
  },
  {
    Studiekode: '209 583',
    Studienavn: 'Organisasjon og ledelse, deltid, nettbasert',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 53.5,
  },
  {
    Studiekode: '194 579',
    Studienavn: 'Sykepleie, fleksibelt',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 33.8,
    ORD: 53.5,
  },
  {
    Studiekode: '194 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 49.5,
    ORD: 53.5,
  },
  {
    Studiekode: '215 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 46,
    ORD: 53.4,
  },
  {
    Studiekode: '211 554',
    Studienavn: 'Paramedisin',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 45.2,
    ORD: 53.4,
  },
  {
    Studiekode: '194 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 50.6,
    ORD: 53.4,
  },
  {
    Studiekode: '184 784',
    Studienavn: 'Geofysikk - meteorologi og oseanografi (siv.ing.)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 51.9,
    ORD: 53.4,
  },
  {
    Studiekode: '184 189',
    Studienavn: 'Informasjonsvitenskap, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 53.4,
  },
  {
    Studiekode: '194 761',
    Studienavn: 'Elektronisk systemdesign og innovasjon',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 53.4,
    ORD: 53.2,
  },
  {
    Studiekode: '192 310',
    Studienavn: 'Landskapsingeniør',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 48.6,
    ORD: 53.2,
  },
  {
    Studiekode: '184 832',
    Studienavn: 'Kunstig intelligens',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 44.8,
    ORD: 53.2,
  },
  {
    Studiekode: '194 759',
    Studienavn: 'Bygg og infrastruktur',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 51.9,
    ORD: 53.1,
  },
  {
    Studiekode: '194 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 49.2,
    ORD: 53.1,
  },
  {
    Studiekode: '184 698',
    Studienavn: 'Samfunnsøkonomi, master',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 51.4,
    ORD: 53.1,
  },
  {
    Studiekode: '215 749',
    Studienavn: 'Farmasi',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - RESEPTAR',
    ORDF: 40.3,
    ORD: 53,
  },
  {
    Studiekode: '215 603',
    Studienavn: 'Bibliotek- og informasjonsvitenskap, årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 53,
  },
  {
    Studiekode: '203 613',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 53,
  },
  {
    Studiekode: '194 284',
    Studienavn: 'Geografi, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 44.8,
    ORD: 52.9,
  },
  {
    Studiekode: '194 862',
    Studienavn: 'Matematiske fag, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 50.3,
    ORD: 52.8,
  },
  {
    Studiekode: '194 055',
    Studienavn: 'Sykepleie, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 49.2,
    ORD: 52.8,
  },
  {
    Studiekode: '215 369',
    Studienavn: 'Økonomi og administrasjon',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 47.6,
    ORD: 52.7,
  },
  {
    Studiekode: '209 703',
    Studienavn: 'Fysioterapi',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - FYSIO',
    ORDF: 46.8,
    ORD: 52.7,
  },
  {
    Studiekode: '233 681',
    Studienavn: 'Politiutdanning, Oslo',
    Lærested: 'PHS',
    Studiested: 'Oslo',
    Utdanningsområde: 'JUS',
    ORDF: '',
    ORD: 52.6,
  },
  {
    Studiekode: '194 474',
    Studienavn: 'Europastudier med statsvitenskap',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 51,
    ORD: 52.5,
  },
  {
    Studiekode: '194 470',
    Studienavn: 'Shipping management',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORDF: 48.5,
    ORD: 52.5,
  },
  {
    Studiekode: '185 829',
    Studienavn: 'Informatikk: programmering og systemarkitektur',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 52.5,
  },
  {
    Studiekode: '222 589',
    Studienavn: 'Sykepleie, deltid, Hallingdal',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 52.4,
  },
  {
    Studiekode: '215 449',
    Studienavn: 'Anvendt datateknologi',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 38.6,
    ORD: 52.4,
  },
  {
    Studiekode: '185 438',
    Studienavn: 'Samfunnsgeografi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 43,
    ORD: 52.4,
  },
  {
    Studiekode: '184 369',
    Studienavn: 'Samfunnsøkonomi, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 49.1,
    ORD: 52.4,
  },
  {
    Studiekode: '215 850',
    Studienavn: 'Medier og kommunikasjon, bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 45,
    ORD: 52.2,
  },
  {
    Studiekode: '185 615',
    Studienavn: 'Allmenn litteraturvitenskap, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 52.2,
  },
  {
    Studiekode: '184 915',
    Studienavn: 'Geovitenskap, retning geofysikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 50.7,
    ORD: 52.2,
  },
  {
    Studiekode: '184 711',
    Studienavn: 'Havbruk (sivilingeniør)',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 46.4,
    ORD: 52.2,
  },
  {
    Studiekode: '201 676',
    Studienavn: 'Pedagogikk, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'PEDFAG',
    ORDF: 30,
    ORD: 52.1,
  },
  {
    Studiekode: '194 531',
    Studienavn: 'Radiografi, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORDF: 48.6,
    ORD: 52.1,
  },
  {
    Studiekode: '215 051',
    Studienavn: 'Sykepleie, deltid',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 52,
  },
  {
    Studiekode: '209 646',
    Studienavn: 'Mat, ernæring og helse',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORDF: 0,
    ORD: 51.8,
  },
  {
    Studiekode: '194 327',
    Studienavn: 'Biologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 50.7,
    ORD: 51.8,
  },
  {
    Studiekode: '185 713',
    Studienavn: 'Klinisk ernæring',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORDF: 0,
    ORD: 51.8,
  },
  {
    Studiekode: '184 829',
    Studienavn: 'Informatikk: datateknologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 41.8,
    ORD: 51.8,
  },
  {
    Studiekode: '201 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 47.1,
    ORD: 51.7,
  },
  {
    Studiekode: '215 702',
    Studienavn: 'Bioingeniør',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 44.9,
    ORD: 51.6,
  },
  {
    Studiekode: '194 956',
    Studienavn: 'Ingeniør, elektrifisering og digitalisering',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 48.2,
    ORD: 51.6,
  },
  {
    Studiekode: '194 777',
    Studienavn: 'Musikkvitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 49,
    ORD: 51.6,
  },
  {
    Studiekode: '192 784',
    Studienavn: 'Miljøfysikk og fornybar energi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 49.2,
    ORD: 51.6,
  },
  {
    Studiekode: '203 050',
    Studienavn: 'Sykepleie, Bergen, høst',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 48.3,
    ORD: 51.5,
  },
  {
    Studiekode: '194 395',
    Studienavn: 'Informatikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 46.7,
    ORD: 51.5,
  },
  {
    Studiekode: '184 940',
    Studienavn: 'Informatikk: datasikkerhet',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 41.5,
    ORD: 51.5,
  },
  {
    Studiekode: '184 934',
    Studienavn: 'Lektor, 8.-13. trinn, sosiologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 48,
    ORD: 51.5,
  },
  {
    Studiekode: '217 527',
    Studienavn: 'Reiseliv i endring',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORDF: 0,
    ORD: 51.4,
  },
  {
    Studiekode: '185 121',
    Studienavn: 'Kjernefysikk og nukleærteknologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 54,
    ORD: 51.3,
  },
  {
    Studiekode: '222 412',
    Studienavn: 'Informasjonsbehandling',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 51.2,
  },
  {
    Studiekode: '194 769',
    Studienavn: 'Energi og miljø',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 52.8,
    ORD: 51.2,
  },
  {
    Studiekode: '217 876',
    Studienavn: 'Psykologi, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 47.8,
    ORD: 51.1,
  },
  {
    Studiekode: '251 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 43.5,
    ORD: 51,
  },
  {
    Studiekode: '222 701',
    Studienavn: 'Radiografi',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORDF: 42.5,
    ORD: 51,
  },
  {
    Studiekode: '184 306',
    Studienavn: 'Informatikk-matematikk-økonomi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 49.4,
    ORD: 50.9,
  },
  {
    Studiekode: '233 679',
    Studienavn: 'Politiutdanning, Stavern',
    Lærested: 'PHS',
    Studiested: 'Larvik',
    Utdanningsområde: 'JUS',
    ORDF: '',
    ORD: 50.8,
  },
  {
    Studiekode: '194 857',
    Studienavn: 'Fysikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 53,
    ORD: 50.8,
  },
  {
    Studiekode: '185 479',
    Studienavn: 'Filosofi, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 50.8,
  },
  {
    Studiekode: '222 059',
    Studienavn: 'Sykepleie, deltid, Vestfold og Telemark',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: -1,
    ORD: 50.7,
  },
  {
    Studiekode: '150 172',
    Studienavn: 'Friluftsliv',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 30.5,
    ORD: 50.7,
  },
  {
    Studiekode: '203 012',
    Studienavn: 'Ingeniør, maskin, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 47.8,
    ORD: 50.6,
  },
  {
    Studiekode: '215 138',
    Studienavn: 'Administrasjon og ledelse i offentlig virksomhet',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 44.6,
    ORD: 50.5,
  },
  {
    Studiekode: '194 783',
    Studienavn: 'Industriell kjemi, materialer og bioteknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 53.1,
    ORD: 50.5,
  },
  {
    Studiekode: '194 503',
    Studienavn: 'Ingeniør, data - systemutvikling',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 50.8,
    ORD: 50.5,
  },
  {
    Studiekode: '192 299',
    Studienavn: 'Bioteknologi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 49,
    ORD: 50.5,
  },
  {
    Studiekode: '185 883',
    Studienavn: 'Utviklingsstudier og bærekraft',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 45.8,
    ORD: 50.5,
  },
  {
    Studiekode: '184 859',
    Studienavn: 'Geovitenskap, retning geologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 49.3,
    ORD: 50.5,
  },
  {
    Studiekode: '203 351',
    Studienavn: 'Sosiologi, årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 50.4,
  },
  {
    Studiekode: '194 822',
    Studienavn: 'Ingeniør, fornybar energi, Trondheim',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 49.8,
    ORD: 50.4,
  },
  {
    Studiekode: '194 476',
    Studienavn: 'Musikkteknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 37.9,
    ORD: 50.4,
  },
  {
    Studiekode: '194 016',
    Studienavn: 'Ingeniør, logistikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 47.3,
    ORD: 50.4,
  },
  {
    Studiekode: '203 702',
    Studienavn: 'Bioingeniør',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 47.1,
    ORD: 50.2,
  },
  {
    Studiekode: '150 486',
    Studienavn: 'Sport Management',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 46.7,
    ORD: 50.1,
  },
  {
    Studiekode: '209 239',
    Studienavn: 'Krisehåndtering, deltid',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 50,
  },
  {
    Studiekode: '203 060',
    Studienavn: 'Vernepleie, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 43.5,
    ORD: 50,
  },
  {
    Studiekode: '201 369',
    Studienavn: 'Økonomi og administrasjon',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORDF: 48.4,
    ORD: 50,
  },
  {
    Studiekode: '186 530',
    Studienavn: 'Internasjonal beredskap',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 50,
  },
  {
    Studiekode: '184 663',
    Studienavn: 'Medier og kommunikasjon, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 42.4,
    ORD: 50,
  },
  {
    Studiekode: '194 353',
    Studienavn: 'Nautikk',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORDF: 44.6,
    ORD: 49.8,
  },
  {
    Studiekode: '194 240',
    Studienavn: 'Sosiologi, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 46.3,
    ORD: 49.8,
  },
  {
    Studiekode: '194 945',
    Studienavn: 'Lektor i samfunnsfag, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 49,
    ORD: 49.7,
  },
  {
    Studiekode: '203 856',
    Studienavn: 'Ingeniør, elektroteknologi, deltid',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 49.6,
  },
  {
    Studiekode: '192 230',
    Studienavn: 'Eiendom',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 44.4,
    ORD: 49.6,
  },
  {
    Studiekode: '204 051',
    Studienavn: 'Sykepleie, deltid, Namsos',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 49.5,
  },
  {
    Studiekode: '203 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og idrettsfag',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 46.9,
    ORD: 49.5,
  },
  {
    Studiekode: '203 096',
    Studienavn: 'Ingeniør, havteknologi',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 47.5,
    ORD: 49.5,
  },
  {
    Studiekode: '201 050',
    Studienavn: 'Sykepleie, Kristiansand',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 46.7,
    ORD: 49.5,
  },
  {
    Studiekode: '194 021',
    Studienavn: 'Ingeniør, havbruk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 47.6,
    ORD: 49.5,
  },
  {
    Studiekode: '192 949',
    Studienavn: 'By- og regionplanlegging',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 43.8,
    ORD: 49.5,
  },
  {
    Studiekode: '192 369',
    Studienavn: 'Økonomi og administrasjon',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORDF: 46.2,
    ORD: 49.5,
  },
  {
    Studiekode: '185 707',
    Studienavn: 'Farmasi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - FARMASI',
    ORDF: 45.9,
    ORD: 49.5,
  },
  {
    Studiekode: '184 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 44.4,
    ORD: 49.5,
  },
  {
    Studiekode: '194 688',
    Studienavn: 'Ingeniør, kjemi og materialteknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 49,
    ORD: 49.4,
  },
  {
    Studiekode: '184 707',
    Studienavn: 'Farmasi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - FARMASI',
    ORDF: 47.6,
    ORD: 49.4,
  },
  {
    Studiekode: '150 489',
    Studienavn: 'Trenerrollen og idrettspsykologi',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 46.2,
    ORD: 49.3,
  },
  {
    Studiekode: '186 078',
    Studienavn: 'Ingeniør, datateknikk, Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 49.2,
  },
  {
    Studiekode: '185 308',
    Studienavn: 'Kultur og kommunikasjon',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 42.6,
    ORD: 49.2,
  },
  {
    Studiekode: '215 070',
    Studienavn: 'Barnevern',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 43.2,
    ORD: 49.1,
  },
  {
    Studiekode: '194 515',
    Studienavn: 'Økonomi, administrasjon og internasjonal business',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'ØKADM',
    ORDF: 46.5,
    ORD: 49.1,
  },
  {
    Studiekode: '184 878',
    Studienavn: 'Sammenliknende politikk, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 48.5,
    ORD: 49.1,
  },
  {
    Studiekode: '184 752',
    Studienavn: 'Psykologi, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 45.8,
    ORD: 49.1,
  },
  {
    Studiekode: '203 701',
    Studienavn: 'Radiografi',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORDF: 45.6,
    ORD: 49,
  },
  {
    Studiekode: '203 589',
    Studienavn: 'Sykepleie, deltid, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 36.8,
    ORD: 49,
  },
  {
    Studiekode: '194 440',
    Studienavn: 'Bevegelsesvitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'IDRETT',
    ORDF: 46.2,
    ORD: 49,
  },
  {
    Studiekode: '186 081',
    Studienavn: 'Sosialt arbeid, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 33.4,
    ORD: 49,
  },
  {
    Studiekode: '184 453',
    Studienavn: 'Informasjonsvitenskap, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 41,
    ORD: 49,
  },
  {
    Studiekode: '194 684',
    Studienavn: 'Lektor i historie, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 46.7,
    ORD: 48.9,
  },
  {
    Studiekode: '185 950',
    Studienavn: 'Italiensk, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 48.9,
  },
  {
    Studiekode: '209 530',
    Studienavn: 'Beredskap og krisehåndtering',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 48.8,
  },
  {
    Studiekode: '203 049',
    Studienavn: 'Nautikk med integrert praksis',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORDF: 40.5,
    ORD: 48.8,
  },
  {
    Studiekode: '185 851',
    Studienavn: 'Medier og kommunikasjon, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 42.1,
    ORD: 48.8,
  },
  {
    Studiekode: '184 743',
    Studienavn: 'Tannpleie',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 44.3,
    ORD: 48.8,
  },
  {
    Studiekode: '222 044',
    Studienavn: 'Skipsfart og logistikk',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORDF: 42.7,
    ORD: 48.6,
  },
  {
    Studiekode: '211 187',
    Studienavn: 'IT, nettbasert',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 48.6,
  },
  {
    Studiekode: '201 663',
    Studienavn: 'Kommunikasjon, medieproduksjon, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 40.8,
    ORD: 48.6,
  },
  {
    Studiekode: '194 070',
    Studienavn: 'Barnevern',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 46.7,
    ORD: 48.6,
  },
  {
    Studiekode: '184 238',
    Studienavn: 'Sammenliknende politikk, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 45.7,
    ORD: 48.6,
  },
  {
    Studiekode: '201 597',
    Studienavn: 'Lektor, 8.-13. trinn, m/idrett i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 48.9,
    ORD: 48.5,
  },
  {
    Studiekode: '185 923',
    Studienavn: 'Midtøsten-studier med arabisk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 48.5,
  },
  {
    Studiekode: '184 437',
    Studienavn: 'Musikkvitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 39.2,
    ORD: 48.5,
  },
  {
    Studiekode: '254 515',
    Studienavn: 'Økonomi og administrasjon, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 46.8,
    ORD: 48.4,
  },
  {
    Studiekode: '192 783',
    Studienavn: 'Kjemi og bioteknologi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 48.6,
    ORD: 48.4,
  },
  {
    Studiekode: '223 454',
    Studienavn: 'Journalistikk',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 46.5,
    ORD: 48.3,
  },
  {
    Studiekode: '185 880',
    Studienavn: 'Sosiologi, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 43.3,
    ORD: 48.2,
  },
  {
    Studiekode: '194 701',
    Studienavn: 'Radiografi, Gjøvik',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORDF: 41.6,
    ORD: 48.1,
  },
  {
    Studiekode: '194 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'PEDFAG',
    ORDF: 41.1,
    ORD: 48.1,
  },
  {
    Studiekode: '224 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 39.5,
    ORD: 48,
  },
  {
    Studiekode: '215 618',
    Studienavn: 'Drama og teaterkommunikasjon, årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 48,
  },
  {
    Studiekode: '185 684',
    Studienavn: 'Lektor, 8.-13. trinn, historie',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 44.2,
    ORD: 48,
  },
  {
    Studiekode: '215 876',
    Studienavn: 'Psykologi med vekt på adferdsanalyse',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 42.1,
    ORD: 47.9,
  },
  {
    Studiekode: '194 060',
    Studienavn: 'Vernepleie',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 44.2,
    ORD: 47.9,
  },
  {
    Studiekode: '201 684',
    Studienavn: 'Lektor, 8.-13. trinn, m/historie i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 51.1,
    ORD: 47.8,
  },
  {
    Studiekode: '185 565',
    Studienavn: 'Italiensk, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 47.8,
  },
  {
    Studiekode: '184 870',
    Studienavn: 'Europastudier',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 45.9,
    ORD: 47.8,
  },
  {
    Studiekode: '233 682',
    Studienavn: 'Politiutdanning, Bodø',
    Lærested: 'PHS',
    Studiested: 'Bodø',
    Utdanningsområde: 'JUS',
    ORDF: '',
    ORD: 47.7,
  },
  {
    Studiekode: '201 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'PEDFAG',
    ORDF: 43.7,
    ORD: 47.7,
  },
  {
    Studiekode: '150 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og idrettsfag',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 46.2,
    ORD: 47.7,
  },
  {
    Studiekode: '209 061',
    Studienavn: 'Vernepleie, deltid, Lillehammer',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 47.6,
  },
  {
    Studiekode: '222 602',
    Studienavn: 'Digital mediedesign, Notodden',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 47.5,
  },
  {
    Studiekode: '217 530',
    Studienavn: 'Byplanlegging og samfunnssikkerhet',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 42.1,
    ORD: 47.5,
  },
  {
    Studiekode: '194 860',
    Studienavn: 'Kjemi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 48.2,
    ORD: 47.5,
  },
  {
    Studiekode: '192 468',
    Studienavn: 'Samfunnsøkonomi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORDF: 44.7,
    ORD: 47.5,
  },
  {
    Studiekode: '185 478',
    Studienavn: 'Arkeologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 36.4,
    ORD: 47.5,
  },
  {
    Studiekode: '185 073',
    Studienavn: 'Idéhistorie, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 47.5,
  },
  {
    Studiekode: '150 185',
    Studienavn: 'Treningslære',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 39.6,
    ORD: 47.4,
  },
  {
    Studiekode: '201 060',
    Studienavn: 'Vernepleie',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 42.1,
    ORD: 47.3,
  },
  {
    Studiekode: '222 136',
    Studienavn: 'Digital mediedesign, Hallingdal',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 47.2,
  },
  {
    Studiekode: '251 059',
    Studienavn: 'Sykepleie, deltid, Sandvika',
    Lærested: 'VID',
    Studiested: 'Bærum',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 47.1,
  },
  {
    Studiekode: '217 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 43.8,
    ORD: 47.1,
  },
  {
    Studiekode: '203 700',
    Studienavn: 'Ergoterapi',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORDF: 43.9,
    ORD: 47.1,
  },
  {
    Studiekode: '185 314',
    Studienavn: 'Klima, miljø og menneske',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 38.8,
    ORD: 47.1,
  },
  {
    Studiekode: '186 468',
    Studienavn: 'Økonomi og administrasjon, Alta',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 47,
  },
  {
    Studiekode: '185 211',
    Studienavn: 'Nordisk, særlig norsk, språk og litteratur',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 47,
  },
  {
    Studiekode: '251 063',
    Studienavn: 'Vernepleie, deltid, Sandvika',
    Lærested: 'VID',
    Studiested: 'Bærum',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 46.9,
  },
  {
    Studiekode: '217 220',
    Studienavn: 'Læring og psykologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'PEDFAG',
    ORDF: 42,
    ORD: 46.9,
  },
  {
    Studiekode: '150 485',
    Studienavn: 'Trening, helse og prestasjon',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 44.4,
    ORD: 46.9,
  },
  {
    Studiekode: '217 046',
    Studienavn: 'Film- og tvproduksjon',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 44.3,
    ORD: 46.8,
  },
  {
    Studiekode: '215 004',
    Studienavn: 'Ingeniør, data',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 46.8,
  },
  {
    Studiekode: '194 090',
    Studienavn: 'Ingeniør, automatisering og intelligente systemer, Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 40.8,
    ORD: 46.8,
  },
  {
    Studiekode: '186 876',
    Studienavn: 'Psykologi, bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 44.3,
    ORD: 46.8,
  },
  {
    Studiekode: '184 851',
    Studienavn: 'Medier og kommunikasjon, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 43.5,
    ORD: 46.6,
  },
  {
    Studiekode: '251 055',
    Studienavn: 'Sykepleie, Bergen',
    Lærested: 'VID',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 43.8,
    ORD: 46.5,
  },
  {
    Studiekode: '215 050',
    Studienavn: 'Sykepleie, Oslo',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 40.2,
    ORD: 46.5,
  },
  {
    Studiekode: '217 369',
    Studienavn: 'Økonomi og administrasjon',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ØKADM',
    ORDF: 44.9,
    ORD: 46.3,
  },
  {
    Studiekode: '194 184',
    Studienavn: 'Biologi og kjemi, realfag',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 47.6,
    ORD: 46.3,
  },
  {
    Studiekode: '215 700',
    Studienavn: 'Ergoterapi',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORDF: 36.9,
    ORD: 46.2,
  },
  {
    Studiekode: '186 664',
    Studienavn: 'Ledelse, deltid',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 46.2,
  },
  {
    Studiekode: '209 876',
    Studienavn: 'Psykologi',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 44.8,
    ORD: 46.1,
  },
  {
    Studiekode: '194 298',
    Studienavn: 'Biomarin innovasjon',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'REALFAG',
    ORDF: 45.9,
    ORD: 46.1,
  },
  {
    Studiekode: '185 582',
    Studienavn: 'Japan-studier med japansk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 46.1,
  },
  {
    Studiekode: '222 051',
    Studienavn: 'Sykepleie, Drammen',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 36.2,
    ORD: 46,
  },
  {
    Studiekode: '203 927',
    Studienavn: 'Sosiologi, bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 45.9,
  },
  {
    Studiekode: '201 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORDF: 45.2,
    ORD: 45.9,
  },
  {
    Studiekode: '201 070',
    Studienavn: 'Barnevern',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 42.9,
    ORD: 45.9,
  },
  {
    Studiekode: '192 322',
    Studienavn: 'Skogfag',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 40.3,
    ORD: 45.8,
  },
  {
    Studiekode: '185 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'PEDFAG',
    ORDF: 37.6,
    ORD: 45.8,
  },
  {
    Studiekode: '185 715',
    Studienavn: 'Honoursprogram, Humaniora, Filosofi og lingvistikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 45.8,
  },
  {
    Studiekode: '222 054',
    Studienavn: 'Sykepleie, Porsgrunn',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 35,
    ORD: 45.7,
  },
  {
    Studiekode: '254 359',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ØKADM',
    ORDF: 45.4,
    ORD: 45.6,
  },
  {
    Studiekode: '194 704',
    Studienavn: 'Audiologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - AUDIO',
    ORDF: 38.9,
    ORD: 45.6,
  },
  {
    Studiekode: '194 346',
    Studienavn: 'Matvitenskap, teknologi og bærekraft',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 44.8,
    ORD: 45.6,
  },
  {
    Studiekode: '185 212',
    Studienavn: 'Norsk som andrespråk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 45.6,
  },
  {
    Studiekode: '255 752',
    Studienavn: 'Psykologi, årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 40.8,
    ORD: 45.5,
  },
  {
    Studiekode: '222 353',
    Studienavn: 'Nautikk',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORDF: 38.5,
    ORD: 45.5,
  },
  {
    Studiekode: '194 699',
    Studienavn: 'Ingeniør, skipsingeniør',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 42.2,
    ORD: 45.5,
  },
  {
    Studiekode: '204 056',
    Studienavn: 'Sykepleie, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 42.1,
    ORD: 45.4,
  },
  {
    Studiekode: '201 702',
    Studienavn: 'Bioingeniør',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 45,
    ORD: 45.4,
  },
  {
    Studiekode: '186 743',
    Studienavn: 'Tannpleie',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 45.7,
    ORD: 45.4,
  },
  {
    Studiekode: '185 934',
    Studienavn: 'Lektor, 8.-13. trinn, samfunnsfag',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 44.6,
    ORD: 45.4,
  },
  {
    Studiekode: '215 085',
    Studienavn: 'Arkivvitenskap',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 45.3,
  },
  {
    Studiekode: '209 062',
    Studienavn: 'Vernepleie, deltid, Kongsvinger',
    Lærested: 'INN',
    Studiested: 'Kongsvinger',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 45.3,
  },
  {
    Studiekode: '201 052',
    Studienavn: 'Sykepleie, Grimstad',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 41.2,
    ORD: 45.3,
  },
  {
    Studiekode: '222 050',
    Studienavn: 'Sykepleie, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 33.6,
    ORD: 45.2,
  },
  {
    Studiekode: '201 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 45.4,
    ORD: 45.2,
  },
  {
    Studiekode: '201 359',
    Studienavn: 'Markedsføring og ledelse',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORDF: 45,
    ORD: 45.2,
  },
  {
    Studiekode: '194 594',
    Studienavn: 'Ergoterapi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORDF: 42.9,
    ORD: 45.2,
  },
  {
    Studiekode: '222 251',
    Studienavn: 'Visuell kommunikasjon',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 36,
    ORD: 45.1,
  },
  {
    Studiekode: '203 753',
    Studienavn: 'Landmåling og eiendomsdesign',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 41.4,
    ORD: 45.1,
  },
  {
    Studiekode: '186 955',
    Studienavn: 'Sikkerhet og beredskap',
    Lærested: 'UIT',
    Studiested: 'Sør-Varanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 45.1,
  },
  {
    Studiekode: '215 054',
    Studienavn: 'Sykepleie, Kjeller',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 35.7,
    ORD: 45,
  },
  {
    Studiekode: '224 070',
    Studienavn: 'Barnevern',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 38.3,
    ORD: 44.8,
  },
  {
    Studiekode: '251 162',
    Studienavn: 'Verdibasert ledelse og administrasjon',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 44.5,
  },
  {
    Studiekode: '201 851',
    Studienavn: 'Kommunikasjon, medieproduksjon, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 42.2,
    ORD: 44.5,
  },
  {
    Studiekode: '204 054',
    Studienavn: 'Sykepleie, deltid, Mo i Rana',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 44.4,
  },
  {
    Studiekode: '203 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, kroppsøving',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 44.6,
    ORD: 44.4,
  },
  {
    Studiekode: '185 555',
    Studienavn: 'Matematikk: data, modellering og beregninger',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 44.3,
  },
  {
    Studiekode: '203 055',
    Studienavn: 'Sykepleie, deltid, Haugesund',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 44.2,
  },
  {
    Studiekode: '203 203',
    Studienavn: 'Folkehelsearbeid',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORDF: 40.9,
    ORD: 44.1,
  },
  {
    Studiekode: '194 486',
    Studienavn: 'Samfunns- og idrettsvitenskap',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'IDRETT',
    ORDF: 43.1,
    ORD: 44.1,
  },
  {
    Studiekode: '185 893',
    Studienavn: 'Lingvistikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 44.1,
  },
  {
    Studiekode: '251 081',
    Studienavn: 'Sosialt arbeid, deltid',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: '',
    ORD: 44,
  },
  {
    Studiekode: '224 052',
    Studienavn: 'Sykepleie, Indre Østfold',
    Lærested: 'HIØ',
    Studiested: 'Indre Østfold',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 30.1,
    ORD: 44,
  },
  {
    Studiekode: '224 050',
    Studienavn: 'Sykepleie, Fredrikstad',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 36.5,
    ORD: 44,
  },
  {
    Studiekode: '222 060',
    Studienavn: 'Vernepleie',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 44,
  },
  {
    Studiekode: '215 395',
    Studienavn: 'Informasjonsteknologi, bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 44,
  },
  {
    Studiekode: '194 025',
    Studienavn: 'Ingeniør, mekatronikk og produktdesign',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 41.8,
    ORD: 44,
  },
  {
    Studiekode: '184 240',
    Studienavn: 'Sosiologi, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 43.3,
    ORD: 43.9,
  },
  {
    Studiekode: '215 200',
    Studienavn: 'Kunst og design - kunst og formidling',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 43.8,
  },
  {
    Studiekode: '209 743',
    Studienavn: 'Tannpleie',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - ODONT',
    ORDF: 37.5,
    ORD: 43.8,
  },
  {
    Studiekode: '194 870',
    Studienavn: 'Europastudier med engelsk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 43.2,
    ORD: 43.8,
  },
  {
    Studiekode: '194 432',
    Studienavn: 'Logistikkledelse',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORDF: 35.4,
    ORD: 43.8,
  },
  {
    Studiekode: '194 085',
    Studienavn: 'Arkiv, museum og dokumentasjonsforvaltning',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 43.8,
  },
  {
    Studiekode: '222 330',
    Studienavn: 'Økonomi og ledelse, Drammen',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'ØKADM',
    ORDF: 40.2,
    ORD: 43.7,
  },
  {
    Studiekode: '194 880',
    Studienavn: 'Sosiologi, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 42.1,
    ORD: 43.7,
  },
  {
    Studiekode: '255 903',
    Studienavn: 'Psykologi, bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 43.6,
    ORD: 43.6,
  },
  {
    Studiekode: '217 881',
    Studienavn: 'Statsvitenskap, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 44.4,
    ORD: 43.6,
  },
  {
    Studiekode: '251 050',
    Studienavn: 'Sykepleie, Oslo',
    Lærested: 'VID',
    Studiested: 'Oslo',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 34.5,
    ORD: 43.5,
  },
  {
    Studiekode: '217 050',
    Studienavn: 'Sykepleie',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 40,
    ORD: 43.5,
  },
  {
    Studiekode: '201 642',
    Studienavn: 'Visuell kunst og formidling, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 43.5,
  },
  {
    Studiekode: '194 300',
    Studienavn: 'Digital infrastruktur og cybersikkerhet, Gjøvik',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 43.5,
  },
  {
    Studiekode: '185 879',
    Studienavn: 'Sosialantropologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 36.8,
    ORD: 43.5,
  },
  {
    Studiekode: '201 618',
    Studienavn: 'Teater, skuespill og regi, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 41.4,
    ORD: 43.3,
  },
  {
    Studiekode: '186 701',
    Studienavn: 'Radiografi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - RADIO',
    ORDF: 45.8,
    ORD: 43.3,
  },
  {
    Studiekode: '186 331',
    Studienavn: 'Fiskeri- og havbruksvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 37.5,
    ORD: 43.3,
  },
  {
    Studiekode: '217 642',
    Studienavn: 'Kunst og håndverk',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 43.2,
  },
  {
    Studiekode: '215 060',
    Studienavn: 'Vernepleie',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 43.1,
  },
  {
    Studiekode: '192 810',
    Studienavn: 'Anvendt robotikk',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 43.1,
    ORD: 43.1,
  },
  {
    Studiekode: '201 260',
    Studienavn: 'IT og informasjonssystemer, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 32.6,
    ORD: 43,
  },
  {
    Studiekode: '209 080',
    Studienavn: 'Sosialt arbeid',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 36.4,
    ORD: 42.8,
  },
  {
    Studiekode: '222 955',
    Studienavn: 'IT og ledelse',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 42.5,
  },
  {
    Studiekode: '209 053',
    Studienavn: 'Sykepleie, Kongsvinger',
    Lærested: 'INN',
    Studiested: 'Kongsvinger',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 42.5,
  },
  {
    Studiekode: '217 454',
    Studienavn: 'Journalistikk',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 43,
    ORD: 42.4,
  },
  {
    Studiekode: '203 550',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, samfunnsfag',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 42.2,
    ORD: 42.4,
  },
  {
    Studiekode: '222 568',
    Studienavn: 'Ungdomsarbeid og fritidspedagogikk',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 42.3,
  },
  {
    Studiekode: '222 369',
    Studienavn: 'Økonomi og ledelse, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'ØKADM',
    ORDF: 35.9,
    ORD: 42.3,
  },
  {
    Studiekode: '204 696',
    Studienavn: 'Trafikklærer',
    Lærested: 'NORD',
    Studiested: 'Stjørdal',
    Utdanningsområde: 'LÆRER - ANNET',
    ORDF: '',
    ORD: 42.2,
  },
  {
    Studiekode: '204 583',
    Studienavn: 'Personalledelse og kompetanseutvikling, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 42.2,
  },
  {
    Studiekode: '204 162',
    Studienavn: 'Personalledelse og kompetanseutvikling, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 42.1,
  },
  {
    Studiekode: '201 796',
    Studienavn: 'Teater, skuespill og regi, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 43.9,
    ORD: 42.1,
  },
  {
    Studiekode: '224 060',
    Studienavn: 'Vernepleie',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 42,
  },
  {
    Studiekode: '222 070',
    Studienavn: 'Barnevern',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 33.9,
    ORD: 42,
  },
  {
    Studiekode: '211 449',
    Studienavn: 'IT og digitalisering',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 42,
  },
  {
    Studiekode: '185 437',
    Studienavn: 'Musikkvitenskap',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 42,
  },
  {
    Studiekode: '209 035',
    Studienavn: 'Økonomi og administrasjon, Lillehammer, bachelor',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORDF: 41.9,
    ORD: 41.8,
  },
  {
    Studiekode: '194 591',
    Studienavn: 'Økonomi og ledelse, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORDF: 42.1,
    ORD: 41.8,
  },
  {
    Studiekode: '222 017',
    Studienavn: 'Ingeniør, elektro - elektro-automasjon og robotikk',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 41.7,
  },
  {
    Studiekode: '203 061',
    Studienavn: 'Vernepleie, deltid',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 41.7,
  },
  {
    Studiekode: '192 759',
    Studienavn: 'Byggeteknikk og arkitektur',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 44.7,
    ORD: 41.7,
  },
  {
    Studiekode: '185 852',
    Studienavn: 'Pedagogikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'PEDFAG',
    ORDF: 31.2,
    ORD: 41.7,
  },
  {
    Studiekode: '251 061',
    Studienavn: 'Vernepleie, deltid, Stavanger',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 41.6,
  },
  {
    Studiekode: '194 851',
    Studienavn: 'Medievitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 41.7,
    ORD: 41.6,
  },
  {
    Studiekode: '209 395',
    Studienavn: 'Kunstig intelligens',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 41.5,
  },
  {
    Studiekode: '194 852',
    Studienavn: 'Pedagogikk, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'PEDFAG',
    ORDF: 37,
    ORD: 41.5,
  },
  {
    Studiekode: '186 615',
    Studienavn: 'Allmenn litteraturvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 41.5,
  },
  {
    Studiekode: '194 005',
    Studienavn: 'Ingeniør, elektro',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 43.1,
    ORD: 41.2,
  },
  {
    Studiekode: '217 012',
    Studienavn: 'Ingeniør, maskin',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 41.6,
    ORD: 41.1,
  },
  {
    Studiekode: '194 359',
    Studienavn: 'Markedsføring, innovasjon og ledelse',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'ØKADM',
    ORDF: 41.9,
    ORD: 41.1,
  },
  {
    Studiekode: '217 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 37.9,
    ORD: 41,
  },
  {
    Studiekode: '209 050',
    Studienavn: 'Sykepleie, Elverum',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 31.3,
    ORD: 41,
  },
  {
    Studiekode: '203 170',
    Studienavn: 'Engelsk',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 41,
  },
  {
    Studiekode: '194 367',
    Studienavn: 'Sosialantropologi, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 39.5,
    ORD: 41,
  },
  {
    Studiekode: '194 050',
    Studienavn: 'Sykepleie, Gjøvik',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 37.5,
    ORD: 41,
  },
  {
    Studiekode: '185 462',
    Studienavn: 'Kunsthistorie og visuelle studier, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 41,
  },
  {
    Studiekode: '194 056',
    Studienavn: 'Sykepleie, Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 38.9,
    ORD: 40.9,
  },
  {
    Studiekode: '203 053',
    Studienavn: 'Sykepleie, Stord, høst',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 35,
    ORD: 40.8,
  },
  {
    Studiekode: '203 056',
    Studienavn: 'Sykepleie, Haugesund, høst',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 40.3,
  },
  {
    Studiekode: '201 240',
    Studienavn: 'Sosiologi',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 36.2,
    ORD: 40.2,
  },
  {
    Studiekode: '194 160',
    Studienavn: 'Økonomi og ledelse, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 40,
  },
  {
    Studiekode: '204 576',
    Studienavn: 'Sosialt arbeid, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 34.2,
    ORD: 39.9,
  },
  {
    Studiekode: '194 149',
    Studienavn: 'Grafisk design',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 40.1,
    ORD: 39.9,
  },
  {
    Studiekode: '209 052',
    Studienavn: 'Sykepleie, deltid, Elverum',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 39.8,
  },
  {
    Studiekode: '203 657',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, samfunnsfag',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 40,
    ORD: 39.8,
  },
  {
    Studiekode: '203 162',
    Studienavn: 'Administrasjon og ledelse',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 39.8,
  },
  {
    Studiekode: '251 053',
    Studienavn: 'Sykepleie, deltid, Sandnessjøen',
    Lærested: 'VID',
    Studiested: 'Alstahaug',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 39.7,
  },
  {
    Studiekode: '215 012',
    Studienavn: 'Ingeniør, maskin',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 38.3,
    ORD: 39.7,
  },
  {
    Studiekode: '194 299',
    Studienavn: 'Bioingeniør, Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 41.4,
    ORD: 39.6,
  },
  {
    Studiekode: '254 470',
    Studienavn: 'Økonomi og administrasjon, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 39.5,
    ORD: 39.5,
  },
  {
    Studiekode: '224 900',
    Studienavn: 'Arbeids- og velferdsfag',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 0,
    ORD: 39.5,
  },
  {
    Studiekode: '222 881',
    Studienavn: 'Statsvitenskap',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 38.4,
    ORD: 39.5,
  },
  {
    Studiekode: '201 852',
    Studienavn: 'Pedagogikk, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'PEDFAG',
    ORDF: 36.8,
    ORD: 39.4,
  },
  {
    Studiekode: '185 205',
    Studienavn: 'Matematikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 39.4,
  },
  {
    Studiekode: '217 470',
    Studienavn: 'Digital serviceledelse - dataanalyse',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORDF: 35.8,
    ORD: 39.2,
  },
  {
    Studiekode: '201 456',
    Studienavn: 'Film, litteratur og teater',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 39.2,
    ORD: 39.2,
  },
  {
    Studiekode: '194 023',
    Studienavn: 'Ingeniør, bygg, Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 43,
    ORD: 39.2,
  },
  {
    Studiekode: '251 502',
    Studienavn: 'Sosial bærekraft og ledelse',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 39.1,
  },
  {
    Studiekode: '222 352',
    Studienavn: 'Marinteknisk drift',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - MARITIM',
    ORDF: 0,
    ORD: 39,
  },
  {
    Studiekode: '224 702',
    Studienavn: 'Bioingeniør',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 0,
    ORD: 38.9,
  },
  {
    Studiekode: '204 060',
    Studienavn: 'Vernepleie, Namsos',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 38.8,
  },
  {
    Studiekode: '192 591',
    Studienavn: 'Økonomi, ledelse og IT',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORDF: 42.6,
    ORD: 38.8,
  },
  {
    Studiekode: '222 867',
    Studienavn: 'Forretningsjus og økonomi',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'JUS',
    ORDF: 39.7,
    ORD: 38.5,
  },
  {
    Studiekode: '222 368',
    Studienavn: 'Eiendomsmegling',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORDF: 38.8,
    ORD: 38.2,
  },
  {
    Studiekode: '194 004',
    Studienavn: 'Ingeniør, data - cybersikkerhet og programmering',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 41.5,
    ORD: 38.2,
  },
  {
    Studiekode: '184 880',
    Studienavn: 'Sosiologi, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 39.3,
    ORD: 38.2,
  },
  {
    Studiekode: '185 237',
    Studienavn: 'Øst-Europa-studier',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 38,
  },
  {
    Studiekode: '254 895',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 37.4,
    ORD: 37.9,
  },
  {
    Studiekode: '211 589',
    Studienavn: 'Sykepleie, Kristiansund',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 30.9,
    ORD: 37.6,
  },
  {
    Studiekode: '222 098',
    Studienavn: 'Design i nye medier',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 37.5,
  },
  {
    Studiekode: '204 796',
    Studienavn: 'Vernepleie, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 37.5,
  },
  {
    Studiekode: '223 845',
    Studienavn: 'Medieproduksjon',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 39.6,
    ORD: 37.2,
  },
  {
    Studiekode: '184 852',
    Studienavn: 'Pedagogikk, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 36,
    ORD: 36.8,
  },
  {
    Studiekode: '217 525',
    Studienavn: 'Digital serviceledelse - tjenesteinnovasjon',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORDF: 31.3,
    ORD: 36.7,
  },
  {
    Studiekode: '192 766',
    Studienavn: 'Teknologi og produktutvikling',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 36.7,
  },
  {
    Studiekode: '203 081',
    Studienavn: 'Sosialt arbeid, Sogndal',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 0,
    ORD: 36.5,
  },
  {
    Studiekode: '204 050',
    Studienavn: 'Sykepleie, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 37.1,
    ORD: 36.3,
  },
  {
    Studiekode: '201 238',
    Studienavn: 'Statsvitenskap, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 38.1,
    ORD: 36.2,
  },
  {
    Studiekode: '186 369',
    Studienavn: 'Økonomi og administrasjon, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ØKADM',
    ORDF: 39.1,
    ORD: 36,
  },
  {
    Studiekode: '217 070',
    Studienavn: 'Barnevern',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 36.5,
    ORD: 35.8,
  },
  {
    Studiekode: '204 591',
    Studienavn: 'Human Resource Management (HRM), Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 35.7,
  },
  {
    Studiekode: '215 484',
    Studienavn: 'Utviklingsstudier, bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 35.4,
  },
  {
    Studiekode: '203 368',
    Studienavn: 'Eiendomsmegling, økonomi og jus',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'ØKADM',
    ORDF: 39.2,
    ORD: 35.4,
  },
  {
    Studiekode: '201 850',
    Studienavn: 'Kommunikasjon, kommunikasjon og medier, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 38.5,
    ORD: 35.4,
  },
  {
    Studiekode: '201 900',
    Studienavn: 'Sosiologi',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 37.5,
    ORD: 35.1,
  },
  {
    Studiekode: '201 189',
    Studienavn: 'IT og informasjonssystemer, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 32.9,
  },
  {
    Studiekode: '203 054',
    Studienavn: 'Sykepleie, Førde, høst',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 31.6,
  },
  {
    Studiekode: '254 035',
    Studienavn: 'Økonomi og administrasjon, Kristiansand',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORDF: 36.3,
    ORD: 30.4,
  },
  {
    Studiekode: '186 055',
    Studienavn: 'Sykepleie, Harstad',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 43.4,
    ORD: 29.6,
  },
  {
    Studiekode: '204 368',
    Studienavn: 'Eiendomsmegling og markedsanalyser',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 33.8,
    ORD: 28.5,
  },
  {
    Studiekode: '258 936',
    Studienavn: 'Teologi, formidling og ledelse',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 929',
    Studienavn: 'Teologi og misjon, samlingsbasert',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 910',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE), deltid',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 653',
    Studienavn: 'Teologi, deltid',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 652',
    Studienavn: 'Teologi, nettbasert',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 539',
    Studienavn: 'Teologi og sjelesorg',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 480',
    Studienavn: 'Teologi og misjon',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 329',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE)',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 196',
    Studienavn: 'Teologi',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '258 195',
    Studienavn: 'Bibel og misjon',
    Lærested: 'FIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 792',
    Studienavn: 'Musikk og helse',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 777',
    Studienavn: 'Musikk',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 714',
    Studienavn: 'Musikk og musikkproduksjon',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 536',
    Studienavn: 'Teologi, deltid',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 480',
    Studienavn: 'Teologi, bachelor',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 202',
    Studienavn: 'Miljøterapi i et mangfoldig samfunn',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '255 195',
    Studienavn: 'Teologi, årsstudium',
    Lærested: 'AHS',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 910',
    Studienavn:
      'Kristendom, religion, livssyn og etikk (KRLE), Bergen, nettbasert',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 879',
    Studienavn: 'Interkulturell kompetanse, Bergen, bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 877',
    Studienavn: 'Interkulturell kompetanse, Kristiansand, bachelor, nettbasert',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 852',
    Studienavn: 'Pedagogikk, bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 771',
    Studienavn: 'Teologi, Bergen, profesjonsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 670',
    Studienavn: 'Naturfag, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 667',
    Studienavn: 'Musikk',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 662',
    Studienavn: 'Naturfag, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 654',
    Studienavn:
      'Interkulturell kompetanse, Kristiansand, årsstudium, nettbasert',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 653',
    Studienavn: 'Praktisk teologi og ledelse, Trondheim',
    Lærested: 'NLA',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 652',
    Studienavn: 'Praktisk teologi og ledelse, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 642',
    Studienavn: 'Kunst og håndverk',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 604',
    Studienavn: 'Journalistikk, årsstudium',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 591',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Stavanger',
    Lærested: 'NLA',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 553',
    Studienavn: 'Bibelen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 552',
    Studienavn: 'Teologi, Trondheim, bachelor',
    Lærested: 'NLA',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 550',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 529',
    Studienavn: 'Barnehagelærer, deltid, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 525',
    Studienavn: 'Innovasjon, markedsføring og ledelse, Kristiansand',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 517',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, kroppsøving, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 508',
    Studienavn: 'Kroppsøving, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 507',
    Studienavn: 'Kroppsøving, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 480',
    Studienavn: 'Teologi, Bergen, bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 454',
    Studienavn: 'Journalistikk, bachelor',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 440',
    Studienavn: 'Idrettsvitenskap, bachelor',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 393',
    Studienavn: 'Bærekraftig entreprenørskap og innovasjon',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 369',
    Studienavn: 'Økonomi og administrasjon, Stavanger',
    Lærested: 'NLA',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 367',
    Studienavn: 'Interkulturell kompetanse, Bergen, årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 329',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE), Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 242',
    Studienavn: 'Samfunnsfag, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 210',
    Studienavn: 'Norsk',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 196',
    Studienavn: 'Kristendom, religion, livssyn og etikk (KRLE), Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 195',
    Studienavn: 'Praktisk teologi og ledelse, Bergen',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 185',
    Studienavn: 'Idrettsvitenskap, årsstudium',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 170',
    Studienavn: 'Engelsk',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 131',
    Studienavn: 'Barnehagelærer, deltid, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'NLA',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 088',
    Studienavn: 'Kommunikasjon, livssyn, kristen apologetikk',
    Lærested: 'NLA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, kroppsøving, Oslo',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '253 135',
    Studienavn: 'Barnehagelærer, deltid, Orkanger',
    Lærested: 'DMMH',
    Studiested: 'Orkland',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '253 134',
    Studienavn: 'Barnehagelærer, ledelse, deltid',
    Lærested: 'DMMH',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '253 133',
    Studienavn: 'Barnehagelærer, deltid, Trondheim',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '253 132',
    Studienavn: 'Barnehagelærer, natur- og friluftsliv',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '253 131',
    Studienavn: 'Barnehagelærer, musikk, drama, kunst og håndverk',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '253 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'DMMH',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '251 791',
    Studienavn: 'Sosial bærekraft',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '251 771',
    Studienavn: 'Teologi, profesjonsstudium',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '251 700',
    Studienavn: 'Ergoterapi',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '251 480',
    Studienavn: 'Teologi, bachelor',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '251 060',
    Studienavn: 'Vernepleie',
    Lærested: 'VID',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '231 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, samisk',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '231 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, samisk',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '231 467',
    Studienavn: 'Reinnæringsstudier',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '231 131',
    Studienavn: 'Samisk barnehagelærerutdanning - fleksibel, deltid',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '231 065',
    Studienavn: 'Duodji og design',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '231 064',
    Studienavn: 'Samisk språk og litteratur',
    Lærested: 'SA/SH',
    Studiested: 'Guovdageaidnu Kautok',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 913',
    Studienavn: 'Spansk, deltid',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 912',
    Studienavn: 'Spansk',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 901',
    Studienavn: 'Språk (engelsk/fransk/spansk/tysk)',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 895',
    Studienavn: 'Innovasjon og prosjektledelse',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 845',
    Studienavn: 'Digitale medier og design',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 690',
    Studienavn: 'Tysk, deltid',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 680',
    Studienavn: 'Samfunnsfag',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 649',
    Studienavn: 'Kroppsøving og idrett',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 626',
    Studienavn: 'Religion, livssyn og etikk',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 620',
    Studienavn: 'Informasjonsteknologi',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 610',
    Studienavn: 'Fransk',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 516',
    Studienavn: 'Regnskap',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 455',
    Studienavn: 'Internasjonal kommunikasjon',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 453',
    Studienavn: 'Informasjonssystemer',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 398',
    Studienavn: 'Bedriftsøkonomi',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 369',
    Studienavn: 'Økonomi og administrasjon , deltid',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 270',
    Studienavn: 'Informatikk: design og utvikling av IT-systemer',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 244',
    Studienavn: 'Tysk',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 210',
    Studienavn: 'Norsk',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 174',
    Studienavn: 'Fransk, deltid',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 170',
    Studienavn: 'Engelsk',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 131',
    Studienavn: 'Barnehagelærer, deltid',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 035',
    Studienavn: 'Økonomi og administrasjon',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 012',
    Studienavn: 'Ingeniør, maskin: industriell produktutvikling',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 005',
    Studienavn: 'Ingeniør, elektro: elektronikk og grønn energi',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 004',
    Studienavn: 'Ingeniør, data',
    Lærested: 'HIØ',
    Studiested: 'Halden',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '224 003',
    Studienavn: 'Ingeniør, bygg og miljø',
    Lærested: 'HIØ',
    Studiested: 'Fredrikstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 902',
    Studienavn: 'Religion og kultur',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 891',
    Studienavn: 'Språk og litteratur',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 667',
    Studienavn: 'Musikk, årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 649',
    Studienavn: 'Idrett og kroppsøving, årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 630',
    Studienavn: 'Design, kunst og håndverk, årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 618',
    Studienavn: 'Teaterproduksjon',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 605',
    Studienavn: 'Friluftsliv',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 529',
    Studienavn: 'Barnehagelærer, deltid',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 513',
    Studienavn: 'Historie, deltid',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 485',
    Studienavn: 'Idrett og kroppsøving, bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 472',
    Studienavn: 'Design, kunst og håndverk, bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 453',
    Studienavn: 'PR, kommunikasjon og media',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 452',
    Studienavn: 'Samfunnsutvikling',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 451',
    Studienavn: 'Animasjon',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 440',
    Studienavn: 'Friluftsliv og naturguide',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 439',
    Studienavn: 'Skuespill og scenekunst',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 437',
    Studienavn: 'Musikk, bachelor',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 285',
    Studienavn: 'Samfunnskunnskap',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 211',
    Studienavn: 'Norsk (nordisk), deltid',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 170',
    Studienavn: 'Engelsk, deltid',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 080',
    Studienavn: 'Sosialt arbeid, sosionom',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '223 070',
    Studienavn: 'Sosialt arbeid, barnevernspedagog',
    Lærested: 'HVO',
    Studiested: 'Volda',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 956',
    Studienavn: 'Ingeniør, data - softwareutvikling',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 954',
    Studienavn: 'Språk og litteratur - norsk, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 950',
    Studienavn: 'Norsk, Bø',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 924',
    Studienavn: 'Språk og litteratur - spansk, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 922',
    Studienavn: 'Språk og litteratur - engelsk',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 913',
    Studienavn: 'Spansk',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 912',
    Studienavn: 'Spansk, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 894',
    Studienavn: 'Optometri',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 885',
    Studienavn: 'Språk og formidling',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 880',
    Studienavn: 'Sosiologi, bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 824',
    Studienavn: 'Ingeniør, maskin - konstruksjonsteknikk',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 781',
    Studienavn: 'Kunst og design i samfunn - visuell kunst',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 717',
    Studienavn: 'Internasjonal forståelse og samarbeid',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 715',
    Studienavn: 'Historie, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 699',
    Studienavn: 'Ingeniør, elektronikk-mikroteknologi og datasystem',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 688',
    Studienavn: 'Ingeniør, kjemi - ren energi- og prosessteknologi',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 684',
    Studienavn: 'Lektor, historie, 8.-13. trinn',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 672',
    Studienavn: 'Norsk, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 667',
    Studienavn: 'Musikk, kultur og mangfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 642',
    Studienavn: 'Kunst og design',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 637',
    Studienavn: 'Tegning - bilde og form',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 629',
    Studienavn: 'Folkemusikk, årsstudium',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 628',
    Studienavn: 'Tradisjonskunst: tre, metall eller tekstilhåndverk',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 625',
    Studienavn: 'Økonomi og administrasjon, Kongsberg',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 623',
    Studienavn: 'Engelsk, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 622',
    Studienavn: 'Engelsk, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 613',
    Studienavn: 'Historie, Bø, årsstudium',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 606',
    Studienavn: 'Engelsk, Bø',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 605',
    Studienavn: 'Natur og miljø',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 574',
    Studienavn: 'Lærer, 1.-13. trinn, design, kunst og håndverk',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 573',
    Studienavn: 'Håndverk og design',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 569',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Porsgrunn',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 567',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Notodden',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 557',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Porsgrunn',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 548',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Drammen',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 529',
    Studienavn: 'Barnehagelærer, Notodden',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 513',
    Studienavn: 'Historie, Bø, bachelor',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 503',
    Studienavn: 'Ingeniør, data - cyber physical systems',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 488',
    Studienavn: 'Idrett, trening og ledelse',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 481',
    Studienavn: 'Historie, Vestfold, bachelor',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 474',
    Studienavn: 'Språk og litteratur - norsk',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 471',
    Studienavn: 'Kunst og design i samfunn - håndverk og design',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 470',
    Studienavn: 'Økonomi og ledelse, Bø',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 468',
    Studienavn: 'Entreprenørskap og bærekraftig innovasjon',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 456',
    Studienavn: 'Språk og litteratur - engelsk, deltid',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 455',
    Studienavn: 'Språk og litteratur - spansk',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 449',
    Studienavn: 'IT og informasjonssystemer, Bø',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 443',
    Studienavn: 'Folkemusikk, bachelor',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 442',
    Studienavn: 'Tradisjonskunst; tre, metall eller tekstilhåndverk',
    Lærested: 'USN',
    Studiested: 'Vinje',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 440',
    Studienavn: 'Trening, ernæring og helse',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 414',
    Studienavn: 'Økonomi og ledelse, Hønefoss',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 404',
    Studienavn: 'Økonomi og ledelse, Kongsberg',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 398',
    Studienavn: 'Økonomi og administrasjon, deltid',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 395',
    Studienavn: 'IT og informasjonssystemer, Hønefoss',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 366',
    Studienavn: 'Idéhistorie',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 359',
    Studienavn: 'Markedsføringsledelse',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 315',
    Studienavn: 'Natur- og miljøforvaltning',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 308',
    Studienavn: 'Kulturledelse',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 302',
    Studienavn: 'Friluftslivveiledning',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 240',
    Studienavn: 'Sosiologi, årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 218',
    Studienavn: 'Økonomi og administrasjon, Hallingdal',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 210',
    Studienavn: 'Norsk, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 189',
    Studienavn: 'IT og informasjonssystemer, Hallingdal',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 188',
    Studienavn: 'IT og informasjonssystemer, deltid',
    Lærested: 'USN',
    Studiested: 'Gol',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 185',
    Studienavn: 'Idrett',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 179',
    Studienavn: 'Historie, Vestfold, årsstudium',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 172',
    Studienavn: 'Friluftsliv',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 164',
    Studienavn: 'Økonomi og administrasjon, Bø',
    Lærested: 'USN',
    Studiested: 'Midt-Telemark',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 134',
    Studienavn: 'Barnehagelærer, deltid, Notodden',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 133',
    Studienavn: 'Barnehagelærer, Porsgrunn',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 132',
    Studienavn: 'Barnehagelærer, Drammen',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 131',
    Studienavn: 'Barnehagelærer, deltid, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 130',
    Studienavn: 'Barnehagelærer, Vestfold',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 097',
    Studienavn: 'Økonomi og administrasjon, Hønefoss',
    Lærested: 'USN',
    Studiested: 'Ringerike',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 090',
    Studienavn: 'Ingeniør, elektro - informatikk og automatisering',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 088',
    Studienavn: 'Skriving og formidling',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Notodden',
    Lærested: 'USN',
    Studiested: 'Notodden',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Drammen',
    Lærested: 'USN',
    Studiested: 'Drammen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 069',
    Studienavn: 'Ingeniør, maskin - produktutvikling',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 068',
    Studienavn: 'Ingeniør, elektronikk - kybernetikk',
    Lærested: 'USN',
    Studiested: 'Kongsberg',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 033',
    Studienavn: 'Ingeniør, bygg - plan og infrastruktur',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 012',
    Studienavn: 'Ingeniør, maskin - produktdesign',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 006',
    Studienavn: 'Ingeniør, elektro - elkraft og bærekraftig energi',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 004',
    Studienavn: 'Ingeniør, data - cybersikkerhet',
    Lærested: 'USN',
    Studiested: 'Horten',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '222 003',
    Studienavn: 'Ingeniør, bygg - konstruksjon og byggdesign',
    Lærested: 'USN',
    Studiested: 'Porsgrunn',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 956',
    Studienavn: 'Ingeniør, medisinsk teknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 889',
    Studienavn: 'Nordisk språk og litteratur, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 887',
    Studienavn: 'Engelsk språk og litteratur, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 880',
    Studienavn: 'Sosiologi, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 860',
    Studienavn: 'Biologisk kjemi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 852',
    Studienavn: 'Skolefritidspedagogikk, deltid',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 844',
    Studienavn: 'Lektor, 8.-13. trinn, humanistiske fag',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 813',
    Studienavn: 'Industriell økonomi, alle linjer',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 760',
    Studienavn: 'Datateknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 747',
    Studienavn: 'Matematikk og fysikk',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 675',
    Studienavn: 'Ingeniør, bygg, studieretning konstruksjonsteknikk',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 667',
    Studienavn: 'Musikkopplæring',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 649',
    Studienavn: 'Idrett',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 618',
    Studienavn: 'Teater og Drama',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 482',
    Studienavn: 'Religion, kultur og samfunn, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 440',
    Studienavn: 'Idrettsvitenskap',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 255',
    Studienavn: 'Hotelledelse',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REISELIV',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 240',
    Studienavn: 'Sosiologi, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 233',
    Studienavn: 'Realfag og teknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 211',
    Studienavn: 'Nordisk språk og litteratur, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 205',
    Studienavn: 'Matematikk',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 196',
    Studienavn: 'Religion, kultur og samfunn, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 177',
    Studienavn: 'Kommunikasjon',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 172',
    Studienavn: 'Friluftsliv',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 170',
    Studienavn: 'Engelsk språk og litteratur, årsstudium',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 131',
    Studienavn: 'Barnehagelærer, deltid',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 067',
    Studienavn: 'Ingeniør, bygg, studieretning byplanlegging',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 033',
    Studienavn: 'Ingeniør, bygg, studieretning infrastruktur',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 015',
    Studienavn: 'Ingeniør, energi- og petroleumsteknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 009',
    Studienavn: 'Ingeniør, miljøteknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 005',
    Studienavn: 'Ingeniør, elektroteknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '217 004',
    Studienavn: 'Ingeniør, datateknologi',
    Lærested: 'UIS',
    Studiested: 'Stavanger',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 958',
    Studienavn: 'Yrkesfaglærer i teknologi og industrifag, nettbasert',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 954',
    Studienavn: 'Yrkesfaglærer i elektro og datateknologi, nettbasert',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 953',
    Studienavn: 'Yrkesfaglærer i bygg og anleggsteknikk, nettbasert',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 848',
    Studienavn: 'Fotojournalistikk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 822',
    Studienavn: 'Ingeniør, energi og miljø i bygg',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 691',
    Studienavn: 'Utviklingsstudier, årsstudium',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 657',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, matematikk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 655',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, engelsk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, norsk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 574',
    Studienavn: 'Lærer, 1.-13. trinn, design, kunst og håndverk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og idrettsfag',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 535',
    Studienavn: 'Yrkesfaglærer i frisør, blomster, interiør, ekspd.',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 533',
    Studienavn: 'Yrkesfaglærer i informasjonstekn. og medieprod.',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 503',
    Studienavn: 'Ingeniør, matematisk modellering og datavitenskap',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 466',
    Studienavn: 'Norsk tegnspråk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 439',
    Studienavn: 'Drama og teaterkommunikasjon, bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 336',
    Studienavn: 'Bibliotek- og informasjonsvitenskap, bachelor',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 242',
    Studienavn: 'Migrasjons- og integrasjonsforvaltning',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 221',
    Studienavn: 'Tegnspråk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 135',
    Studienavn: 'Barnehagelærer, arbeidsplassbasert, deltid',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 131',
    Studienavn: 'Barnehagelærer, deltid',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 129',
    Studienavn: 'Yrkesfaglærer i teknologi og industrifag',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 127',
    Studienavn: 'Yrkesfaglærer i elektro og datateknologi',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 126',
    Studienavn: 'Yrkesfaglærer i håndverk, design og prod.utvikling',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 124',
    Studienavn: 'Yrkesfaglærer i restaurant- og matfag',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 123',
    Studienavn: 'Yrkesfaglærer i helse- og oppvekstfag',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 109',
    Studienavn: 'Yrkesfaglærer i bygg og anleggsteknikk',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 105',
    Studienavn: 'Yrkesfaglærer i salg, service og reiseliv',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '215 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn med steinerpedagogikk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 025',
    Studienavn: 'Ingeniør, elektro - automatisering og robotikk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 024',
    Studienavn: 'Ingeniør, elektro - elektronikk',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 009',
    Studienavn: 'Ingeniør, bioteknologi og kjemi',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '215 003',
    Studienavn: 'Ingeniør, bygg',
    Lærested: 'OSLOMET',
    Studiested: 'Oslo',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 866',
    Studienavn: 'Petroleumslogistikk og økonomi',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 841',
    Studienavn: 'Politikk, juss og administrasjon',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 627',
    Studienavn: 'Logistikk',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 488',
    Studienavn: 'Sport Management',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 432',
    Studienavn: 'Marin logistikk og økonomi',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 389',
    Studienavn: 'Bærekraftig logistikk og sirkulær økonomi',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 369',
    Studienavn: 'Økonomi og administrasjon',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 292',
    Studienavn: 'Logistikk og Supply Chain Management',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 232',
    Studienavn: 'Organisasjon og personalledelse',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 218',
    Studienavn: 'Juss og økonomi',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 189',
    Studienavn: 'IT',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 188',
    Studienavn: 'Helseteknologi og digitalisering, deltid',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 185',
    Studienavn: 'Idrett og adventure',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 164',
    Studienavn: 'Bedriftsøkonomi',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 061',
    Studienavn: 'Vernepleie, deltid',
    Lærested: 'HIM',
    Studiested: 'Kristiansund',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '211 060',
    Studienavn: 'Vernepleie',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '211 050',
    Studienavn: 'Sykepleie, Molde',
    Lærested: 'HIM',
    Studiested: 'Molde',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 935',
    Studienavn: 'Lektor, 8.-13. trinn, språkfag',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 872',
    Studienavn: 'Internasjonale studier , bachelor',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 867',
    Studienavn: 'Ledelse og digitalisering',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 852',
    Studienavn: 'Pedagogikk, bachelor',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 839',
    Studienavn: 'Spillteknologi og simulering',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 733',
    Studienavn: 'Jordbruk, deltid',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 730',
    Studienavn: 'Jordbruk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 702',
    Studienavn: 'Bioingeniør',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 672',
    Studienavn: 'Norsk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 667',
    Studienavn: 'Musikk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 664',
    Studienavn: 'Organisasjon og ledelse, deltid',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, samlingsbasert',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 624',
    Studienavn: 'Spillpedagogikk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 623',
    Studienavn: 'Engelsk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 575',
    Studienavn: 'Lærer, 1.-13. trinn, musikk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 568',
    Studienavn: 'Pedagogikk - fleksibelt, deltid',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 566',
    Studienavn: 'Lærer, 1.-13. trinn, kroppsøving og Idrettsfag',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 548',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, samlingsbasert',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 525',
    Studienavn: 'Organisasjon og ledelse, Lillehammer',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 516',
    Studienavn: 'Regnskap og økonomirådgivning',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 507',
    Studienavn: 'Idrett',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 489',
    Studienavn: 'Idrettsvitenskap- helse og treningsfysiologi',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 488',
    Studienavn: 'Idrett - spesialisering i trenerrollen, deltid',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 485',
    Studienavn: 'Sport Management',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 479',
    Studienavn: 'Filosofi, politikk og økonomi',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 470',
    Studienavn: 'Serviceledelse og markedsføring',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 437',
    Studienavn: 'Musikkformidling',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 409',
    Studienavn: 'Økologisk landbruk, deltid',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 369',
    Studienavn: 'Økonomi og administrasjon, Rena, bachelor',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 366',
    Studienavn: 'Filosofi',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 323',
    Studienavn: 'Utmarksforvaltning',
    Lærested: 'INN',
    Studiested: 'Stor-Elvdal',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 322',
    Studienavn: 'Skogbruk',
    Lærested: 'INN',
    Studiested: 'Stor-Elvdal',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 320',
    Studienavn: 'Agronomi',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 311',
    Studienavn: 'Landbruksteknikk',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 288',
    Studienavn: 'Internasjonale studier , årsstudium',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 242',
    Studienavn: 'Samfunnsfag',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 232',
    Studienavn: 'Økonomi og administrasjon, Lillehammer, årsstudium',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 185',
    Studienavn: 'Kroppsøving og idrett',
    Lærested: 'INN',
    Studiested: 'Elverum',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 183',
    Studienavn: 'Animasjon og digital kunst',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 172',
    Studienavn: 'Jakt, fiske og naturveiledning',
    Lærested: 'INN',
    Studiested: 'Stor-Elvdal',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 164',
    Studienavn: 'Bedriftsøkonomi',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 162',
    Studienavn: 'Organisasjon og ledelse, Rena',
    Lærested: 'INN',
    Studiested: 'Åmot',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 132',
    Studienavn: 'Barnehagelærer, samlingsbasert',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 131',
    Studienavn: 'Barnehagelærerutdanning- arbeidsplassbasert, deltid',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 130',
    Studienavn: 'Barnehagelærer',
    Lærested: 'INN',
    Studiested: 'Hamar',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 070',
    Studienavn: 'Barnevern',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 060',
    Studienavn: 'Vernepleie',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '209 051',
    Studienavn: 'Sykepleie, deltid, Tynset',
    Lærested: 'INN',
    Studiested: 'Tynset',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 955',
    Studienavn: 'Human Resource Management (HRM), Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 952',
    Studienavn: 'Trening, helse og prestasjon',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 934',
    Studienavn: 'Lektor, 8.-13. trinn, samfunnsfag',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 880',
    Studienavn: 'Sosiologi og samfunnsanalyse',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 872',
    Studienavn: 'Internasjonale relasjoner, bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 867',
    Studienavn: 'Havbruksdrift og ledelse',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 747',
    Studienavn: 'Farmasi, deltid',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - RESEPTAR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 736',
    Studienavn: 'Skogfag, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 717',
    Studienavn: 'Internasjonale relasjoner, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 680',
    Studienavn: 'Samfunnsfag',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 673',
    Studienavn: 'Spill- og opplevelsesteknologi',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 667',
    Studienavn: 'Musikk, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 665',
    Studienavn: 'Grunnskolelærer, 1-10. trinn',
    Lærested: 'NORD',
    Studiested: 'Nesna',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 664',
    Studienavn: 'Personalledelse og kompetanseutvikling, Mo i Rana',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 657',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 625',
    Studienavn: 'Økonomi og administrasjon, Steinkjer, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 623',
    Studienavn: 'Engelsk, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 613',
    Studienavn: 'Historie, nettbasert',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 605',
    Studienavn: 'Friluftsliv, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 597',
    Studienavn: 'Lektor, 8.-13. trinn, kroppsøving og idrettsfag',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 596',
    Studienavn: 'Friluftsliv, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 590',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, lulesamisk',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: -1,
    ORD: 0,
  },
  {
    Studiekode: '204 581',
    Studienavn: 'Yrkesfaglærer, naturbruk',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 575',
    Studienavn: 'Lærer i praktiske og estetiske fag, 1.-13., musikk',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - LUPE1-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 570',
    Studienavn: 'Barnehagelærer, deltid, Støren',
    Lærested: 'NORD',
    Studiested: 'Midtre Gauldal',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 564',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, sørsamisk',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 551',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 529',
    Studienavn: 'Barnehagelærer, deltid, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 527',
    Studienavn: 'Luftfartsledelse, deltid',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 504',
    Studienavn: 'Dyrepleie',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 488',
    Studienavn: 'Idrettsvitenskap',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 486',
    Studienavn: 'Idrett',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 473',
    Studienavn: 'Markedsføring og ledelse',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 454',
    Studienavn: 'Journalistikk',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 453',
    Studienavn: 'Økonomi, digitalisering og forretningsutvikling',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 438',
    Studienavn: 'Geografi og samfunnsplanlegging',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 437',
    Studienavn: 'Musikk, bachelor',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 434',
    Studienavn: 'Trafikklærer for tunge klasser',
    Lærested: 'NORD',
    Studiested: 'Stjørdal',
    Utdanningsområde: 'LÆRER - ANNET',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 430',
    Studienavn: 'CG Art og animasjon',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 427',
    Studienavn: 'Animal Science',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 421',
    Studienavn: 'Husdyrvelferd',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 420',
    Studienavn: 'Natur- og kulturminneoppsyn',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 404',
    Studienavn: 'Økonomi og administrasjon, Steinkjer, bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 398',
    Studienavn: 'Økonomi og digitalisering',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 396',
    Studienavn: 'Geografi',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: -1,
    ORD: 0,
  },
  {
    Studiekode: '204 388',
    Studienavn: 'Naturforvaltning, bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 345',
    Studienavn: 'Økonomi og administrasjon - siviløkonom',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 342',
    Studienavn: 'Økonomi og administrasjon, Bodø, bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 327',
    Studienavn: 'Biologi, bachelor',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 322',
    Studienavn: 'Skogfag, bachelor',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 321',
    Studienavn: 'Husdyrvitenskap',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 249',
    Studienavn: 'Sosiologi, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 240',
    Studienavn: 'Sosiologi, Levanger',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 231',
    Studienavn: 'Yrkesfaglærer, informasjonsteknologi og medieprod.',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 218',
    Studienavn: 'Økonomi, markedsføring og ledelse, deltid, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 211',
    Studienavn: 'Nordområdestudier',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 209',
    Studienavn: 'Økonomi, markedsføring og ledelse, deltid, Stjørdal',
    Lærested: 'NORD',
    Studiested: 'Stjørdal',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 185',
    Studienavn: 'Personlig trener',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 184',
    Studienavn: 'Biologi, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 172',
    Studienavn: 'Naturforvaltning, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Steinkjer',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 170',
    Studienavn: 'Engelsk, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 164',
    Studienavn: 'Økonomi og administrasjon, Bodø, årsstudium',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 135',
    Studienavn: 'Barnehagelærer, deltid, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 132',
    Studienavn: 'Barnehagelærer, deltid, Nesna',
    Lærested: 'NORD',
    Studiested: 'Nesna',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 130',
    Studienavn: 'Barnehagelærer, deltid, Vesterålen',
    Lærested: 'NORD',
    Studiested: 'Vesterålen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 129',
    Studienavn: 'Yrkesfaglærer i teknologi- og industrifag',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 127',
    Studienavn: 'Yrkesfaglærer i elektro- og datateknologi',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 124',
    Studienavn: 'Yrkesfaglærer, restaurant- og matfag',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 123',
    Studienavn: 'Yrkesfaglærer, helse- og oppvekstfag',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 109',
    Studienavn: 'Yrkesfaglærer, bygg- og anleggsteknikk',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 105',
    Studienavn: 'Yrkesfaglærer i salg, service og reiseliv',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '204 089',
    Studienavn: 'Film- og TV-produksjon',
    Lærested: 'NORD',
    Studiested: 'Levanger',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 080',
    Studienavn: 'Sosialt arbeid, Bodø',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 070',
    Studienavn: 'Barnevern',
    Lærested: 'NORD',
    Studiested: 'Bodø',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 058',
    Studienavn: 'Sykepleie, Namsos',
    Lærested: 'NORD',
    Studiested: 'Namsos',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 055',
    Studienavn: 'Sykepleie, Mo i Rana',
    Lærested: 'NORD',
    Studiested: 'Mo i Rana',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '204 053',
    Studienavn: 'Sykepleie, deltid, Vesterålen',
    Lærested: 'NORD',
    Studiested: 'Vesterålen',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 956',
    Studienavn: 'Ingeniør, elektroteknologi, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 829',
    Studienavn: 'Informasjonsteknologi, Førde',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 822',
    Studienavn: 'Ingeniør, energiteknologi',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 754',
    Studienavn: 'Reiseliv, markedsføring og ledelse, årsstudium',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REISELIV',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 667',
    Studienavn: 'Musikk',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, musikk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 659',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, mat og helse',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 658',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, norsk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 655',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, matematikk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Sogndal',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 649',
    Studienavn: 'Kroppsøving og idrettsfag',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 599',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, mat og helse',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 590',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Sogndal',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 569',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, KRLE',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 568',
    Studienavn: 'Skolefritidspedagogikk, deltid, Stord',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 567',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, engelsk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 564',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, kunst og håndverk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 560',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, kunst og håndverk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 559',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, KRLE',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 557',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, naturfag',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 551',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, engelsk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 548',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, musikk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 529',
    Studienavn: 'Barnehagelærer, deltid',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 526',
    Studienavn: 'Økonomi og jus',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'JUS',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 515',
    Studienavn: 'Økonomi og administrasjon, Sogndal',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 513',
    Studienavn: 'Historie, bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 509',
    Studienavn: 'Personlig trener',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 505',
    Studienavn: 'Kunst og håndverk',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 485',
    Studienavn: 'Idrett, trening, helse',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 472',
    Studienavn: 'Kunstfag - Musikk og visuell kunst',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 469',
    Studienavn: 'Geologi og geofare',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 466',
    Studienavn: 'Tegnspråk og tolking',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 445',
    Studienavn: 'Barnehagelærer, Sogndal',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 436',
    Studienavn: 'Informasjonsteknologi',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 413',
    Studienavn: 'Skolefritidspedagogikk, deltid, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 404',
    Studienavn: 'Økonomi og administrasjon, Haugesund',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 395',
    Studienavn: 'Informasjonsteknologi, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 330',
    Studienavn: 'Reiseliv, markedsføring og ledelse, bachelor',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'REISELIV',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 310',
    Studienavn: 'Landskapsplanlegging med landskapsarkitektur',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 302',
    Studienavn: 'Friluftsliv',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 246',
    Studienavn: 'Jus',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'JUS',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 185',
    Studienavn: 'Idrett og trening',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 164',
    Studienavn: 'Bedriftsøkonomi',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 135',
    Studienavn: 'Barnehagelærer, Stord',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 130',
    Studienavn: 'Barnehagelærer, Bergen',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Stord',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Stord',
    Lærested: 'HVL',
    Studiested: 'Stord',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 070',
    Studienavn: 'Barnevern',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 068',
    Studienavn: 'Ingeniør, elektroteknologi, Førde',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 062',
    Studienavn: 'Vernepleie, Sogndal',
    Lærested: 'HVL',
    Studiested: 'Sogndal',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 052',
    Studienavn: 'Sykepleie, Førde, vår',
    Lærested: 'HVL',
    Studiested: 'Sunnfjord',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 048',
    Studienavn: 'Ingeniør, elektroteknologi, Haugesund',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 045',
    Studienavn: 'Ingeniør, bærekraftig produksjon og sirkulærøkonom',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 034',
    Studienavn: 'Ingeniør, maskin, Haugesund',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 011',
    Studienavn: 'Ingeniør, marinteknikk',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 009',
    Studienavn: 'Ingeniør, kjemi',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 004',
    Studienavn: 'Ingeniør, data',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 003',
    Studienavn: 'Ingeniør, bygg',
    Lærested: 'HVL',
    Studiested: 'Bergen',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '203 002',
    Studienavn: 'Ingeniør, brannsikkerhet',
    Lærested: 'HVL',
    Studiested: 'Haugesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 945',
    Studienavn: 'Lektor, 8-13, m/samf. kunnsk. i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 935',
    Studienavn: 'Lektor, 8-13 trinn,m/fremmedspr. i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 934',
    Studienavn: 'Lektor, 8.-13. trinn, m/religion i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 912',
    Studienavn: 'Spansk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 889',
    Studienavn: 'Nordisk språk og litteratur, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 887',
    Studienavn: 'Engelsk, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 864',
    Studienavn: 'Samfunnsrettet ernæringsarbeid',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 862',
    Studienavn: 'Industriell matematikk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 843',
    Studienavn: 'Lektor, 8-13 trinn, m/naturfag i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 807',
    Studienavn: 'Kunstig intelligens',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 803',
    Studienavn: 'Ingeniør, elektronikk',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 794',
    Studienavn: 'Kommunikasjon, kommunikasjon og medier, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 767',
    Studienavn: 'Industriell økonomi og teknologiledelse',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 697',
    Studienavn: 'Lektor, 8-13 trinn, m/matematikk i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 690',
    Studienavn: 'Tysk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 687',
    Studienavn: 'Lektor, 8.-13. trinn, m/norsk i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 685',
    Studienavn: 'Lektor, 8.-13. trinn, m/engelsk i første studieår',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 675',
    Studienavn: 'Ingeniør, bygg, fleksibel, deltid',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 670',
    Studienavn: 'Naturfag',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 667',
    Studienavn: 'Musikk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 661',
    Studienavn: 'Fysikk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 652',
    Studienavn: 'Religion, etikk og samfunn, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 649',
    Studienavn: 'Idrett, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 646',
    Studienavn: 'Samfunnsrettet ernæring',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 511',
    Studienavn: 'Lærerutdanning for tospråklige',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 489',
    Studienavn: 'Akademisk e-sport',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 484',
    Studienavn: 'Globale utviklingsstudier, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 482',
    Studienavn: 'Religion, etikk og samfunn, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 479',
    Studienavn: 'Anvendt filosofi',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 474',
    Studienavn: 'Samfunnsplanlegging og kommunikasjon',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 440',
    Studienavn: 'Idrett, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 373',
    Studienavn: 'Biologi, årsstudium, nettbasert',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 366',
    Studienavn: 'Filosofi',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 336',
    Studienavn: 'Skolebibliotekkunnskap, deltid',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 327',
    Studienavn: 'Biologi, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 247',
    Studienavn: 'Globale utviklingsstudier, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 210',
    Studienavn: 'Nordisk språk og litteratur, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 205',
    Studienavn: 'Matematikk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 203',
    Studienavn: 'Folkehelsearbeid',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 200',
    Studienavn: 'Visuell kunst og formidling, bachelor',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 187',
    Studienavn: 'IKT',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 184',
    Studienavn: 'Biologi, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 174',
    Studienavn: 'Fransk',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 172',
    Studienavn: 'Friluftsliv',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 170',
    Studienavn: 'Engelsk, årsstudium',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 149',
    Studienavn: 'Multimedieteknologi og -design',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 132',
    Studienavn: 'Barnehagelærer, Grimstad',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 130',
    Studienavn: 'Barnehagelærer, Kristiansand',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn',
    Lærested: 'UIA',
    Studiested: 'Kristiansand',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 012',
    Studienavn: 'Ingeniør, mekatronikk',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 006',
    Studienavn: 'Ingeniør, fornybar energi',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 004',
    Studienavn: 'Ingeniør, data',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '201 003',
    Studienavn: 'Ingeniør, byggdesign',
    Lærested: 'UIA',
    Studiested: 'Grimstad',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 934',
    Studienavn: 'Lektor i geografi, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 929',
    Studienavn: 'Religionsvitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 924',
    Studienavn: 'Spansk, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 912',
    Studienavn: 'Spansk, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 904',
    Studienavn: 'Kulturminneforvaltning og museum',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 890',
    Studienavn: 'Tysk, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 889',
    Studienavn: 'Nordisk språk, litteratur og norsk som andrespråk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 888',
    Studienavn: 'Fransk, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 887',
    Studienavn: 'Engelsk, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 879',
    Studienavn: 'Sosialantropologi, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 847',
    Studienavn: 'Filmvitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 843',
    Studienavn: 'Lektor i realfag, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 840',
    Studienavn: 'Ingeniør, data - applikasjonsutvikling',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 835',
    Studienavn: 'Ingeniør, fornybar energi, Gjøvik',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 824',
    Studienavn: 'Produktdesign og teknologi, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 796',
    Studienavn: 'Drama og teater, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 795',
    Studienavn: 'Europastudier med tysk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 793',
    Studienavn: 'Europastudier med fransk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 786',
    Studienavn: 'Europastudier med spansk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 715',
    Studienavn: 'Humanistiske fag,  emnestudier',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 689',
    Studienavn: 'Lektor i språkfag/tysk, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 687',
    Studienavn: 'Lektor i språkfag/nordisk, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 686',
    Studienavn: 'Lektor i språkfag/fransk, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 685',
    Studienavn: 'Lektor i språkfag/engelsk, 8.-13. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 673',
    Studienavn: 'Programmering',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 651',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, med matematikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 616',
    Studienavn: 'Fransk med didaktikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 615',
    Studienavn: 'Allmenn litteraturvitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 604',
    Studienavn: 'Webdesign',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 602',
    Studienavn: 'Produktdesign og teknologi, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 588',
    Studienavn: 'Filosofi og etikk - etikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 587',
    Studienavn: 'Ingeniør, byggkonstruksjoner',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 586',
    Studienavn: 'Ingeniør, produksjon og produktutvikling',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 479',
    Studienavn: 'Filosofi og etikk - filosofi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 478',
    Studienavn: 'Arkeologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 466',
    Studienavn: 'Norsk tegnspråk, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 459',
    Studienavn: 'Antikkens kultur og klassiske fag',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 456',
    Studienavn: 'Allmenn litteraturvitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 439',
    Studienavn: 'Drama og teater, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 438',
    Studienavn: 'Geografi, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 437',
    Studienavn: 'Musikkvitenskap, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 427',
    Studienavn: 'Bioteknologi, Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 400',
    Studienavn: 'Etikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 366',
    Studienavn: 'Filosofi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 294',
    Studienavn: 'Latin',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 272',
    Studienavn: 'Kunsthistorie, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 264',
    Studienavn: 'Interaksjonsdesign',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 262',
    Studienavn: 'Filmvitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 244',
    Studienavn: 'Tysk, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 242',
    Studienavn: 'Studier av kunnskap, teknologi og samfunn (STS)',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 222',
    Studienavn: 'Likestilling og mangfold',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 221',
    Studienavn: 'Norsk tegnspråk, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 210',
    Studienavn: 'Nordisk språk og litteratur',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 205',
    Studienavn: 'Matematiske fag, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 200',
    Studienavn: 'Kunsthistorie, bachelor',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 174',
    Studienavn: 'Fransk, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 170',
    Studienavn: 'Engelsk, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 136',
    Studienavn: 'Medievitenskap, årsstudium',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 129',
    Studienavn: 'Yrkesfaglærer, teknologi og industrifag',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '194 127',
    Studienavn: 'Yrkesfaglærer, elektro og datateknologi',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '194 124',
    Studienavn: 'Yrkesfaglærer, restaurant- og matfag',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '194 123',
    Studienavn: 'Yrkesfaglærer, helse- og oppvekstfag',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '194 109',
    Studienavn: 'Yrkesfaglærer, bygg- og anleggsteknikk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - YFAGLÆRER',
    ORDF: '',
    ORD: 0,
  },
  {
    Studiekode: '194 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, med norsk',
    Lærested: 'NTNU',
    Studiested: 'Trondheim',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 072',
    Studienavn: 'Ingeniør, fornybar energi, Ålesund',
    Lærested: 'NTNU',
    Studiested: 'Ålesund',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 069',
    Studienavn: 'Ingeniør, produksjon og produktutvikling,fleksibel, deltid',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '194 067',
    Studienavn: 'Ingeniør,  byggkonstruksjoner (fleksibel), deltid',
    Lærested: 'NTNU',
    Studiested: 'Gjøvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 857',
    Studienavn: 'Energi- og miljøfysikk',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 842',
    Studienavn: 'Plantevitenskap',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 835',
    Studienavn: 'Fornybar energi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 813',
    Studienavn: 'Geoinformatikk',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 809',
    Studienavn: 'Vann- og miljøteknikk',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 804',
    Studienavn: 'Datavitenskap',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 504',
    Studienavn: 'Dyrepleie',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'HELSEFAG - VETERIN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 484',
    Studienavn: 'Internasjonale miljø- og utviklingsstudier',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 406',
    Studienavn: 'Geomatikk',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'TEKNO - ANNET',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 388',
    Studienavn: 'Økologi og naturforvaltning',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 377',
    Studienavn: 'Miljøvitenskap',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 332',
    Studienavn: 'Kjemi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 327',
    Studienavn: 'Biologi',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 321',
    Studienavn: 'Husdyrvitenskap',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'LANDOGHAVBRUK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 315',
    Studienavn: 'Radioaktivitet og miljø',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 298',
    Studienavn: 'Akvakultur',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 253',
    Studienavn: 'Bærekraftig økonomi og ledelse, deltid',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '192 203',
    Studienavn: 'Mat, teknologi og helse',
    Lærested: 'NMBU',
    Studiested: 'Ås',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 936',
    Studienavn: 'Teologi, bachelor',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 934',
    Studienavn: 'Lektor, 8.-13.trinn, religion og samfunnsfag',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 930',
    Studienavn: 'Globalisering og sosial bærekraft',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 929',
    Studienavn: 'Religionsvitenskap',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 910',
    Studienavn: 'Religion',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 482',
    Studienavn: 'Samfunn, politikk og religion',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 480',
    Studienavn: 'Teologi, profesjonsstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 474',
    Studienavn: 'Freds- og konfliktstudier',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 242',
    Studienavn: 'Samfunnsfag',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '190 196',
    Studienavn: 'Teologi, årsstudium',
    Lærested: 'MF',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 956',
    Studienavn: 'Ingeniør, satelitteknologi, Alta/Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 953',
    Studienavn: 'Anvendt fysikk og matematikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 950',
    Studienavn: 'Kvensk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 917',
    Studienavn: 'Ingeniør, prosessteknologi, Alta/Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 910',
    Studienavn: 'Religionsvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 898',
    Studienavn: 'Samfunnsøkonomi med datavitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 889',
    Studienavn: 'Nordisk språk og litteratur',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 887',
    Studienavn: 'Engelsk, bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 886',
    Studienavn: 'Russisk og russlandsstudier',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 881',
    Studienavn: 'Statsvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 880',
    Studienavn: 'Sosiologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 879',
    Studienavn: 'Sosialantropologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 877',
    Studienavn: 'Samfunnssikkerhet og miljø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 867',
    Studienavn: 'Ledelse, innovasjon og marked, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 862',
    Studienavn: 'Fysikk og matematikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 859',
    Studienavn: 'Geovitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 853',
    Studienavn: 'Spesialpedagogikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 852',
    Studienavn: 'Pedagogikk, bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 846',
    Studienavn: 'Medie- og dokumentasjonsvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 844',
    Studienavn: 'Lektor, 8.-13. trinn, språk og samfunnsfag',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 843',
    Studienavn: 'Lektor, 8.-13. trinn, realfag',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 814',
    Studienavn: 'Romfysikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 809',
    Studienavn: 'Fornybar energi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 807',
    Studienavn: 'Informatikk, cybersikkerhet',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 803',
    Studienavn: 'Kunstig intelligens',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 785',
    Studienavn: 'Informatikk, datamaskinsystemer',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 764',
    Studienavn: 'Bærekraftig kjemi og innovasjon',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 752',
    Studienavn: 'Psykologi, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 749',
    Studienavn: 'Farmasi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - RESEPTAR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 709',
    Studienavn: 'Akvamedisin',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 708',
    Studienavn: 'Ernæring',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 702',
    Studienavn: 'Bioingeniørfag',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - BIOING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 700',
    Studienavn: 'Ergoterapi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ERGO',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 677',
    Studienavn: 'Nordsamisk fra begynnernivå',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 675',
    Studienavn: 'Ingeniør, bygg, Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 660',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Alta',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 616',
    Studienavn: 'Russisk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 605',
    Studienavn: 'Arktisk friluftsliv',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 587',
    Studienavn: 'Ingeniør, bygg, VVS',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 586',
    Studienavn: 'Ingeniør, prosessteknologi, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 585',
    Studienavn: 'Informatikk, medisinsk informatikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - SIVING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 570',
    Studienavn: 'Barnehagelærer, Finnsnes, samlingsbasert',
    Lærested: 'UIT',
    Studiested: 'Senja',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 563',
    Studienavn: 'Barnevern, Harstad',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 547',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Alta',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 486',
    Studienavn: 'Trening, prestasjon og helse',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 479',
    Studienavn: 'Filosofi, bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 478',
    Studienavn: 'Arkeologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 475',
    Studienavn: 'Kunsthistorie, bachelor',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 474',
    Studienavn: 'Samfunnsplanlegging',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 470',
    Studienavn: 'Ledelse, innovasjon og marked, Harstad',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 455',
    Studienavn: 'Kvensk og finsk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 427',
    Studienavn: 'Biomedisin',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 395',
    Studienavn: 'Informatikk, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 366',
    Studienavn: 'Filosofi, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 336',
    Studienavn: 'Bibliotek- og dokumentasjonsvitenskap',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 327',
    Studienavn: 'Biologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 302',
    Studienavn: 'Arktisk friluftsliv og naturguiding',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 299',
    Studienavn: 'Bioteknologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 272',
    Studienavn: 'Kunsthistorie, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 225',
    Studienavn: 'Ingeniør, datateknikk, Bodø',
    Lærested: 'UIT',
    Studiested: 'Bodø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 224',
    Studienavn: 'Informatikk, Mo i Rana',
    Lærested: 'UIT',
    Studiested: 'Herøy (Nordland)',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 222',
    Studienavn: 'Likestilling og kjønn',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 220',
    Studienavn: 'Pedagogikk, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'PEDFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 211',
    Studienavn: 'Nordisk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 205',
    Studienavn: 'Matematikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 203',
    Studienavn: 'Menneskelig yteevne i Arktis, bachelor',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 186',
    Studienavn: 'Menneskelig yteevne i Arktis, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 185',
    Studienavn: 'Trening, prestasjon og helse, personlig trener',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 170',
    Studienavn: 'Engelsk, årsstudium',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 164',
    Studienavn: 'Bedriftsøkonomi, deltid',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 162',
    Studienavn: 'Praktisk prosjektledelse, deltid',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 136',
    Studienavn: 'Mediefag',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 132',
    Studienavn: 'Barnehagelærer, Tromsø, samlingsbasert',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 131',
    Studienavn: 'Barnehagelærer, Alta, samlingsbasert',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 130',
    Studienavn: 'Barnehagelærer, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - BHGLÆRER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 084',
    Studienavn: 'Grunnskolelærer, 1.-7. trinn, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - GLU1-7',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 083',
    Studienavn: 'Grunnskolelærer, 5.-10. trinn, Tromsø',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'LÆRER - GLU5-10',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 080',
    Studienavn: 'Sosialt arbeid, Alta',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'HELSEFAG - SOSIONOM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 077',
    Studienavn: 'Ingeniør, prosessteknologi, Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 075',
    Studienavn: 'Ingeniør, bygg, Narvik, nettbasert',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 070',
    Studienavn: 'Barnevern, Alta',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'HELSEFAG - BARNEVER',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 069',
    Studienavn: 'Ingeniør, maskin, Alta/Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 060',
    Studienavn: 'Vernepleie',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'HELSEFAG - VERNEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 056',
    Studienavn: 'Sykepleie, Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 051',
    Studienavn: 'Sykepleie, Hammerfest',
    Lærested: 'UIT',
    Studiested: 'Hammerfest',
    Utdanningsområde: 'HELSEFAG - SYKEPL',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 049',
    Studienavn: 'Nautikk',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 035',
    Studienavn: 'Økonomi og administrasjon, Harstad',
    Lærested: 'UIT',
    Studiested: 'Harstad',
    Utdanningsområde: 'ØKADM',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 027',
    Studienavn: 'Ingeniør, satelitteknologi, Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 024',
    Studienavn: 'Ingeniør, elektronikk',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 023',
    Studienavn: 'Ingeniør, bygg, Alta',
    Lærested: 'UIT',
    Studiested: 'Alta',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 021',
    Studienavn: 'Ingeniør, havteknologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 017',
    Studienavn: 'Ingeniør, automasjon',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 012',
    Studienavn: 'Ingeniør, maskin, Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 007',
    Studienavn: 'Ingeniør, droneteknologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 006',
    Studienavn: 'Ingeniør, elkraftteknikk',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 004',
    Studienavn: 'Ingeniør, datateknikk, Alta/Narvik',
    Lærested: 'UIT',
    Studiested: 'Narvik',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '186 002',
    Studienavn: 'Ingeniør, bærekraftig teknologi',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'TEKNO - INGENIØR',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 953',
    Studienavn: 'Lektor, 8.-13. trinn, Fysikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 935',
    Studienavn: 'Lektor, 8.-13. trinn, fremmedspråk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 929',
    Studienavn: 'Religionsvitenskap, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 924',
    Studienavn: 'Spansk, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 922',
    Studienavn: 'Allmenn litteraturvitenskap, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 920',
    Studienavn: 'Engelsk, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 915',
    Studienavn: 'Geofysikk og klima',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 912',
    Studienavn: 'Spansk, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 909',
    Studienavn: 'Retorikk og språklig kommunikasjon',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 889',
    Studienavn: 'Nordisk: språk, litteratur, retorikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 873',
    Studienavn: 'Tverrfaglige kjønnsstudier, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 863',
    Studienavn: 'Fornybar energi og nanoteknologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 860',
    Studienavn: 'Kjemi og biokjemi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 858',
    Studienavn: 'Geologi og geografi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 857',
    Studienavn: 'Fysikk og astronomi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 856',
    Studienavn: 'Elektronikk, informatikk og teknologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 855',
    Studienavn: 'Lektor, 8.-13. trinn, Biologi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 834',
    Studienavn: 'Lektor, 8.-13. trinn, Geofag',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 832',
    Studienavn: 'Informatikk: robotikk og intelligente systemer',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 817',
    Studienavn: 'Lektor, 8.-13. trinn, norsk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 795',
    Studienavn: 'Tysk, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 793',
    Studienavn: 'Fransk, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 771',
    Studienavn: 'Teologi, profesjonsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 714',
    Studienavn: 'Honoursprogram, Humaniora, Musikkvitenskap',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 697',
    Studienavn: 'Lektor, 8.-13. trinn, Matematikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 690',
    Studienavn: 'Tysk, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 685',
    Studienavn: 'Lektor, 8.-13. trinn, engelsk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 626',
    Studienavn: 'Kristendom og islam',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 598',
    Studienavn: 'Midtøsten-studier med persisk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 592',
    Studienavn: 'Kina-studier med kinesisk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 580',
    Studienavn: 'Lektor, 8.-13. trinn, religion og etikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 483',
    Studienavn: 'Russisk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 482',
    Studienavn: 'Religion og samfunn',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 480',
    Studienavn: 'Teologi, bachelor',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 461',
    Studienavn: 'Midtøsten-studier med tyrkisk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 459',
    Studienavn: 'Klassiske språk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 439',
    Studienavn: 'Estetikk, kunst og samfunn',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 327',
    Studienavn: 'Biovitenskap',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 233',
    Studienavn: 'Realfag',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 200',
    Studienavn: 'Kulturhistorie',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 187',
    Studienavn: 'Informatikk',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 174',
    Studienavn: 'Fransk, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 170',
    Studienavn: 'Engelsk, årsstudium',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '185 074',
    Studienavn: 'Norrøne og keltiske studier',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 954',
    Studienavn: 'Norsk som andrespråk, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 935',
    Studienavn: 'Lektor, 8.-13. trinn, spansk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 929',
    Studienavn: 'Religionsvitenskap, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 924',
    Studienavn: 'Spansk språk og latinamerikastudier, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 923',
    Studienavn: 'Arabisk språk med Midtøstens historie',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 922',
    Studienavn: 'Litteraturvitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 914',
    Studienavn: 'Statistikk og data science',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 912',
    Studienavn: 'Spansk språk og latinamerikastudier, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 911',
    Studienavn: 'Norsk som andrespråk, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 910',
    Studienavn: 'Religionsvitenskap, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 893',
    Studienavn: 'Språkvitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 889',
    Studienavn: 'Nordisk språk og litteratur',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 888',
    Studienavn: 'Fransk, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 887',
    Studienavn: 'Engelsk, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 886',
    Studienavn: 'Russisk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 879',
    Studienavn: 'Sosialantropologi, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 873',
    Studienavn: 'Kjønn, seksualitet og mangfold, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 867',
    Studienavn: 'Politikk og forvaltning, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 865',
    Studienavn: 'Molekylærbiologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 862',
    Studienavn: 'Matematikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 860',
    Studienavn: 'Kjemi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 858',
    Studienavn: 'Geofag og informatikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 857',
    Studienavn: 'Fysikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 844',
    Studienavn: 'Lektor, 8.-13. trinn, engelsk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 843',
    Studienavn: 'Lektor, 8.-13. trinn, naturvit. eller matematikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 817',
    Studienavn: 'Lektor, 8.-13. trinn, nordisk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 792',
    Studienavn: 'Musikkterapi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 708',
    Studienavn: 'Ernæring',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HELSEFAG - ERNÆRING',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 692',
    Studienavn: 'Teatervitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 684',
    Studienavn: 'Lektor, 8.-13. trinn, historie',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 670',
    Studienavn: 'Realfag',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 592',
    Studienavn: 'Kinesisk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 582',
    Studienavn: 'Japansk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 580',
    Studienavn: 'Lektor, 8.-13. trinn, religionsvitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 565',
    Studienavn: 'Italiensk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 555',
    Studienavn: 'Anvendt matematikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 540',
    Studienavn: 'Aktuarfag og dataanalyse',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 481',
    Studienavn: 'Historie, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 479',
    Studienavn: 'Filosofi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 478',
    Studienavn: 'Arkeologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 475',
    Studienavn: 'Kunsthistorie, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 472',
    Studienavn: 'Digital kultur',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 455',
    Studienavn: 'Klassisk filologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 438',
    Studienavn: 'Geografi, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 367',
    Studienavn: 'Sosialantropologi, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 366',
    Studienavn: 'Filosofi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 327',
    Studienavn: 'Biologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'REALFAG',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 272',
    Studienavn: 'Kunsthistorie, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 248',
    Studienavn: 'Geografi, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 244',
    Studienavn: 'Tysk, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 222',
    Studienavn: 'Kjønn, seksualitet og mangfold, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 211',
    Studienavn: 'Nordisk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 200',
    Studienavn: 'Kulturvitenskap',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'ESTETISK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 188',
    Studienavn: 'Informatikk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'INFOTEKN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 179',
    Studienavn: 'Historie, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'HISTORIE',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 174',
    Studienavn: 'Fransk, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 170',
    Studienavn: 'Engelsk, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 162',
    Studienavn: 'Politikk og forvaltning, årsstudium',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SAMFUNN',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '184 074',
    Studienavn: 'Norrøn filologi',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '150 605',
    Studienavn: 'Friluftsliv, helse og naturguiding',
    Lærested: 'NIH',
    Studiested: 'Oslo',
    Utdanningsområde: 'IDRETT',
    ORDF: 0,
    ORD: 0,
  },
  {
    Studiekode: '254 777',
    Studienavn: 'Utøvende musikk, fordypning i låtskriving',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '254 364',
    Studienavn: 'Utøvende musikk og musikkdidaktikk',
    Lærested: 'NLA',
    Studiested: 'Oslo',
    Utdanningsområde: 'ESTETISK',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '215 405',
    Studienavn: 'Produktdesign',
    Lærested: 'OSLOMET',
    Studiested: 'Lillestrøm',
    Utdanningsområde: 'ESTETISK',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '209 847',
    Studienavn: 'Dokumentar- og TV-regi',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '209 534',
    Studienavn: 'Prosjekt- og prod.ledelse for dokumentar og TV',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '209 264',
    Studienavn: 'Dokumentar- og TV-produksjon',
    Lærested: 'INN',
    Studiested: 'Lillehammer',
    Utdanningsområde: 'MEDIEFAG',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '186 554',
    Studienavn: 'Paramedisin',
    Lærested: 'UIT',
    Studiested: 'Tromsø',
    Utdanningsområde: 'HELSEFAG - ANNET',
    ORDF: 51.7,
    ORD: -1,
  },
  {
    Studiekode: '185 572',
    Studienavn: 'Lektor, 8.-13. trinn, Kjemi',
    Lærested: 'UIO',
    Studiested: 'Oslo',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '184 890',
    Studienavn: 'Tysk, bachelor',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'SPRÅK',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '184 689',
    Studienavn: 'Lektor, 8.-13. trinn, tysk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: -1,
    ORD: -1,
  },
  {
    Studiekode: '184 686',
    Studienavn: 'Lektor, 8.-13. trinn, fransk',
    Lærested: 'UIB',
    Studiested: 'Bergen',
    Utdanningsområde: 'LÆRER - LEKTOR 8-13',
    ORDF: -1,
    ORD: -1,
  },
]
export default fieldsOfStudy
